/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://8081.localport.dealer.com/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 75);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = React;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = PropTypes;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommonTester = exports.createStore = exports.Common = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _reactRedux = __webpack_require__(12);

var _react = _interopRequireDefault(__webpack_require__(0));

var _htmlReactParser = _interopRequireDefault(__webpack_require__(72));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommonRenderProp = function CommonRenderProp(props) {
  return props.render(props.commonData);
};

CommonRenderProp.propTypes = {
  render: _propTypes.default.func.isRequired,
  commonData: _propTypes.default.shape({
    labels: _propTypes.default.shape({}).isRequired,
    sitemap: _propTypes.default.shape({}).isRequired,
    prefs: _propTypes.default.shape({}).isRequired,
    flags: _propTypes.default.shape({}).isRequired
  }).isRequired
};

var labelAsHTML = function labelAsHTML(label) {
  var Tag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _react.default.Fragment;
  var html = (0, _htmlReactParser.default)(label);
  return _react.default.createElement(Tag, null, html);
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    commonData: {
      labels: {
        has: function has(key) {
          return state.labels[key] !== undefined;
        },
        get: function get(key) {
          return state.labels[key] || key;
        },
        getKeys: function getKeys() {
          return Object.keys(state.labels);
        },
        getAll: function getAll() {
          return state.labels;
        },
        getHTML: function getHTML(key, Tag) {
          return labelAsHTML(state.labels[key] || key, Tag);
        }
      },
      sitemap: {
        has: function has(alias) {
          return state.sitemap[alias] !== undefined;
        },
        get: function get(alias) {
          return state.sitemap[alias] || null;
        },
        getAll: function getAll() {
          return state.sitemap;
        }
      },
      prefs: state.prefs,
      flags: state.flags
    }
  };
};

var Common = (0, _reactRedux.connect)(mapStateToProps, null, // mapDispatchToProps
null, // mergeProps
{
  pure: false
})(CommonRenderProp);
exports.Common = Common;

var createStore = function createStore(state) {
  return {
    subscribe: function subscribe() {},
    dispatch: function dispatch() {},
    getState: function getState() {
      return state;
    }
  };
};

exports.createStore = createStore;

var CommonTester = function CommonTester(props) {
  var store = createStore({
    flags: props.flags,
    labels: props.labels,
    sitemap: props.sitemap,
    prefs: props.prefs
  });
  return _react.default.createElement(_reactRedux.Provider, {
    store: store
  }, props.render());
};

exports.CommonTester = CommonTester;
CommonTester.propTypes = {
  render: _propTypes.default.func.isRequired,
  labels: _propTypes.default.shape({}),
  sitemap: _propTypes.default.shape({}),
  prefs: _propTypes.default.shape({}),
  flags: _propTypes.default.shape({})
};
CommonTester.defaultProps = {
  labels: {},
  sitemap: {},
  prefs: {},
  flags: {}
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newKey = newKey;
exports.resetTest = resetTest;
exports.getSiteId = getSiteId;
exports.getDeviceType = getDeviceType;
exports.getAccountId = getAccountId;
exports.replacePlaceholders = replacePlaceholders;
exports.isNumbers = isNumbers;
exports.getMonthlyPaymentPerThousand = getMonthlyPaymentPerThousand;
exports.getTotalMonthlyPayments = getTotalMonthlyPayments;
exports.getAdjustedDueAtSigning = getAdjustedDueAtSigning;
exports.getDisclaimerPlaceholderObj = getDisclaimerPlaceholderObj;
exports.filterSummary = filterSummary;
exports.filterFinal = filterFinal;
exports.filterLoanLease = filterLoanLease;
exports.extractEPriceData = extractEPriceData;
exports.parseEPriceButtonLabel = parseEPriceButtonLabel;
exports.titleCase = titleCase;
exports.getDOMContainer = getDOMContainer;
exports.getAffiliatePromotion = exports.getParameterValue = exports.getCookieValue = exports.setClassNames = exports.getDisplayPayments = void 0;

var _constants = __webpack_require__(6);

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/* eslint unknown-word: 0 */
var lastKey = 0;

function newKey(prefix) {
  lastKey += 1;
  return "".concat(prefix).concat(lastKey);
} // for testing purpose


function resetTest() {
  lastKey = 0;
}

function getSiteId(rData) {
  return rData.parameterMap && rData.parameterMap.siteId || rData.siteId;
}

function getDeviceType(rData) {
  return rData.parameterMap && rData.parameterMap.deviceType || rData.deviceType;
}

function getAccountId(rData) {
  return rData.parameterMap && rData.parameterMap.accountId || rData.accountId;
}
/**
 *
 * @param {Array} paymentsArray List of all available LOAN, LEASE payment options
 * @param {Array} keys List of payment object properties by which to sort
 * @param {Array} orders Order in which to sort the payment object to their respective properties, asc is default
 * @return {Object} Selected LOAN, LEASE payment object
 */


var getDisplayPayments = function getDisplayPayments(paymentsArray) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var orders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  /**
   * Sort the payment object based on the list of properties in the `keys` argument.
   * The list is maintained if the sort is based on a missing property
   */
  var sortedPaymentsArray = _toConsumableArray(paymentsArray).sort(function (paymentOne, paymentTwo) {
    var sortConditions = keys.map(function (key, index) {
      var order = orders[index] ? orders[index] : _constants.ASC;
      var criterea = 0;

      switch (order) {
        case _constants.DESC:
          criterea = paymentTwo[key] - paymentOne[key];
          break;

        case _constants.ASC:
        default:
          criterea = paymentOne[key] - paymentTwo[key];
          break;
      }

      return criterea;
    });
    return sortConditions.reduce(function (result, condition) {
      return result || condition;
    });
  });
  /* Select the first LOAN LEASE Payment in the list */


  return sortedPaymentsArray.reduce(function (paymentObj, payment) {
    var _payment$financeType = payment.financeType,
        financeType = _payment$financeType === void 0 ? '' : _payment$financeType;

    if (!paymentObj[financeType]) {
      return _objectSpread({}, paymentObj, _defineProperty({}, financeType, payment));
    }

    return paymentObj;
  }, {});
};

exports.getDisplayPayments = getDisplayPayments;

function replacePlaceholders(labelWithPlaceholder, placeholderValuesObj) {
  // global and ignore case flags which permits replace() to replace each occurrence of matched items
  // ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace
  if (!placeholderValuesObj || Object.entries(placeholderValuesObj).length === 0) {
    if (!labelWithPlaceholder || Object.entries(labelWithPlaceholder).length === 0) {
      return 'Invalid Input';
    }

    return labelWithPlaceholder;
  }

  var regex = new RegExp(Object.keys(placeholderValuesObj).join('|'), 'gi');
  return labelWithPlaceholder.replace(regex, function (matched) {
    return placeholderValuesObj[matched];
  });
}

function numberCheck(num) {
  return typeof num === 'number' && Number.isFinite(num);
}

function isNumbers(nums) {
  if (!nums || !Array.isArray(nums)) {
    return false;
  }

  return nums.every(numberCheck);
} // Logic is copied from PaymentCalculaterTool.java in cms project
// export function getMonthlyPayment(price, downPayment,interestRate,numberOfMonths) {
// 	if (price && downPayment && interestRate && numberOfMonths && isNumbers([price, downPayment,interestRate,numberOfMonths])) {
// 		return Math.round(((price - downPayment) * (interestRate / 100 / 12)) / (1 - (1 + interestRate / 100 / 12) ** (-numberOfMonths)));
// 	}
// 	return '';
// }


function getMonthlyPaymentPerThousand(monthlyPayment, amountFinanced) {
  if (isNumbers([amountFinanced, monthlyPayment]) && amountFinanced > 0) {
    return monthlyPayment / (amountFinanced / 1000.0);
  }

  return '';
}

function getTotalMonthlyPayments(monthlyPayment, term) {
  if (isNumbers([term, monthlyPayment])) {
    return monthlyPayment * term;
  }

  return '';
}

function getAdjustedDueAtSigning(dueAtSigning, rebate) {
  if (isNumbers([dueAtSigning, rebate]) && dueAtSigning - rebate > 0) {
    return dueAtSigning - rebate;
  } else {
    return 0;
  }
}

function getDisclaimerPlaceholderObj(paymentInfo) {
  if (paymentInfo._type === 'LOAN') {
    var apr = paymentInfo.apr,
        dealershipName = paymentInfo.dealershipName,
        downPayment = paymentInfo.downPayment,
        lenderLegalName = paymentInfo.lenderLegalName,
        loanCreditScore = paymentInfo.loanCreditScore,
        monthlyPaymentPerThousand = paymentInfo.monthlyPaymentPerThousand,
        loanProgramEndDate = paymentInfo.loanProgramEndDate,
        term = paymentInfo.term;
    return {
      '<%=loanCreditScore%>': loanCreditScore,
      '<%=APR%>': apr,
      '<%=term%>': term,
      '<%=monthlyPaymentPerThousand%>': monthlyPaymentPerThousand,
      '<%=downPayment%>': downPayment,
      '<%=lenderLegalName%>': lenderLegalName,
      '<%=loanProgramEndDate%>': loanProgramEndDate,
      '<%=dealershipName%>': dealershipName
    };
  } else if (paymentInfo._type === 'LEASE') {
    var leaseCreditScore = paymentInfo.leaseCreditScore,
        leaseLenderLegalName = paymentInfo.leaseLenderLegalName,
        leaseProgramEndDate = paymentInfo.leaseProgramEndDate,
        leaseTerm = paymentInfo.leaseTerm,
        leaseDueAtSigning = paymentInfo.leaseDueAtSigning,
        acquisitionFee = paymentInfo.acquisitionFee,
        capCostTotal = paymentInfo.capCostTotal,
        totalMonthlyPayments = paymentInfo.totalMonthlyPayments,
        capCostReduction = paymentInfo.capCostReduction,
        leaseSecurityDeposit = paymentInfo.leaseSecurityDeposit,
        monthlyPayment = paymentInfo.monthlyPayment,
        excessMileCharge = paymentInfo.excessMileCharge,
        annualMiles = paymentInfo.annualMiles,
        _dealershipName = paymentInfo.dealershipName;
    return {
      '<%=leaseCreditScore%>': leaseCreditScore,
      '<%=leaseLenderLegalName%>': leaseLenderLegalName,
      '<%=leaseProgramEndDate%>': leaseProgramEndDate,
      '<%=leaseTerm%>': leaseTerm,
      '<%=leaseDueAtSigning%>': leaseDueAtSigning,
      '<%=acquisitionFee%>': acquisitionFee,
      '<%=capCostTotal%>': capCostTotal,
      '<%=totalMonthlyPayments%>': totalMonthlyPayments,
      '<%=capCostReduction%>': capCostReduction,
      '<%=leaseSecurityDeposit%>': leaseSecurityDeposit,
      '<%=monthlyPayment%>': monthlyPayment,
      '<%=excessMileCharge%>': excessMileCharge,
      '<%=annualMiles%>': annualMiles,
      '<%=dealershipName%>': _dealershipName
    };
  }

  return {};
} // filter out final price items that do not match the priceType
// this data is consumed by the PricingSummary component


function filterSummary(summaryItems, priceType) {
  return summaryItems.filter(function (item) {
    return item && item.priceType && item.priceType === priceType.toUpperCase() || !item.priceType;
  });
} // filters out the final price from the summary object
// this data is consumed by the PricingSummary component


function filterFinal(summaryItems) {
  return summaryItems.filter(function (item) {
    return item.isFinalPrice === true;
  });
} // filters out the loan and lease from the summary object
// this data is consumed by the PricingLoanLease component


function filterLoanLease(summaryItems) {
  return summaryItems.filter(function (item) {
    return item._type === 'LOAN' || item._type === 'LEASE';
  });
}

function extractEPriceData(ePriceDetail) {
  var ePriceIndex = ePriceDetail.findIndex(function (element) {
    return element.priceType === 'EPRICE';
  }); // ePrice difference should be placed before ePrice value per Rules Provider

  if (ePriceIndex > 0) {
    var ePriceObj = ePriceDetail[ePriceIndex];
    var ePriceValue = ePriceObj && ePriceObj.formatted;
    var ePriceDifference;
    var ePricePrevIndex = ePriceIndex - 1;

    if (ePriceDetail[ePricePrevIndex]._type === '-') {
      ePriceDifference = ePriceDetail[ePricePrevIndex].formatted;
      return {
        ePriceValue: ePriceValue,
        ePriceDifference: ePriceDifference
      };
    } else if (ePriceValue) {
      return {
        ePriceValue: ePriceValue
      };
    }
  }

  return {};
}

function parseEPriceButtonLabel(dPriceArr) {
  var ePriceLabelArr = dPriceArr.filter(function (item) {
    return item._type === 'SHOWEPRICE';
  })[0] || {};
  return ePriceLabelArr.label || 'Show ePrice!';
}

function titleCase(str, sep) {
  return str.toLowerCase().split(sep).map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join('');
}

function getDOMContainer(doc, cssClass) {
  var _doc$querySelectorAll = doc.querySelectorAll(cssClass),
      _doc$querySelectorAll2 = _slicedToArray(_doc$querySelectorAll, 1),
      container = _doc$querySelectorAll2[0];

  return container;
}
/**
 * Filters undefined, null or empty strings as well as boolean false from a list of comma separated items, joins them and returns a string
 * Returns null if 'classes' is empty
 * @param {object} classes - An arguments object
 * From Tim Burgher in vehicle title's utility file
 */


var setClassNames = function setClassNames() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  return classes.concat().filter(function (className) {
    return className;
  }).join(' ') || null;
};
/**
 * Filters list of cookies down to the cookie with name matching cookieName param. if it exists, and returns
 * its value, if it is defined, or an empty string otherwise.
 *
 * @param cookies
 * @param cookieName
 * @returns {String} cookie name if the cookie exists, or empty string.
 */


exports.setClassNames = setClassNames;

var getCookieValue = function getCookieValue() {
  var cookieName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var cookies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return cookies.filter(function (cookie) {
    return cookie.name === cookieName;
  }).reduce(function (value, cookie) {
    return cookie.value || value;
  }, '');
};
/**
 * Returns promo code from the 'affiliate_promotions' url parameter if it exists
 *
 * @param parameterMap
 * @param parameterName
 * @returns {String} parameter value if the url parameter equal to parameterName exists, or empty string.
 */


exports.getCookieValue = getCookieValue;

var getParameterValue = function getParameterValue() {
  var parameterName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var parameterMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return parameterMap[parameterName] || '';
};
/**
 * Returns affiliate offer promo code if one exists in the url parameter 'affiliate_promotions'
 * or in the 'DDC.Affiliate.PromoCode' cookie.
 * Prioritizes url parameter over cookie.
 *
 * @param rData
 * @returns {String} Promo code, if one exists, or empty string
 */


exports.getParameterValue = getParameterValue;

var getAffiliatePromotion = function getAffiliatePromotion() {
  var rData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return getParameterValue('affiliate_promotions', rData.parameterMap) || getCookieValue('DDC.Affiliate.PromoCode', rData.cookies);
};

exports.getAffiliatePromotion = getAffiliatePromotion;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.THE_DEALERSHIP = exports.SLASH_MO = exports.PLUS_TAXES_ASTERISK = exports.PLUS_SALES_TAXES_ASTERISK = exports.PLEASE_CALL = exports.PER_MONTH = exports.LEASE = exports.INSTANT_EPRICE_DISABLED_POPOVER = exports.FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE = exports.FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE = exports.FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE = exports.FINANCE = exports.EST_LEASE_DISCLAIMER_HEADING = exports.EST_FINANCE_DISCLAIMER_HEADING = exports.EPRICE_PENDING = exports.DETAILS = exports.DETAILED_PRICING = exports.DEALERSHIP_NAME_PRICE = exports.CUSTOMIZE_PAYMENTS = void 0;
var CUSTOMIZE_PAYMENTS = 'CUSTOMIZE_PAYMENTS';
exports.CUSTOMIZE_PAYMENTS = CUSTOMIZE_PAYMENTS;
var DEALERSHIP_NAME_PRICE = 'DEALERSHIP_NAME_PRICE';
exports.DEALERSHIP_NAME_PRICE = DEALERSHIP_NAME_PRICE;
var DETAILED_PRICING = 'DETAILED_PRICING';
exports.DETAILED_PRICING = DETAILED_PRICING;
var DETAILS = 'DETAILS';
exports.DETAILS = DETAILS;
var EPRICE_PENDING = 'EPRICE_PENDING';
exports.EPRICE_PENDING = EPRICE_PENDING;
var EST_FINANCE_DISCLAIMER_HEADING = 'EST_FINANCE_DISCLAIMER_HEADING';
exports.EST_FINANCE_DISCLAIMER_HEADING = EST_FINANCE_DISCLAIMER_HEADING;
var EST_LEASE_DISCLAIMER_HEADING = 'EST_LEASE_DISCLAIMER_HEADING';
exports.EST_LEASE_DISCLAIMER_HEADING = EST_LEASE_DISCLAIMER_HEADING;
var FINANCE = 'FINANCE';
exports.FINANCE = FINANCE;
var FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE = 'FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE';
exports.FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE = FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE;
var FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE = 'FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE';
exports.FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE = FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE;
var FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE = 'FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE';
exports.FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE = FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE;
var INSTANT_EPRICE_DISABLED_POPOVER = 'INSTANT_EPRICE_DISABLED_POPOVER';
exports.INSTANT_EPRICE_DISABLED_POPOVER = INSTANT_EPRICE_DISABLED_POPOVER;
var LEASE = 'LEASE';
exports.LEASE = LEASE;
var PER_MONTH = 'PER_MONTH';
exports.PER_MONTH = PER_MONTH;
var PLEASE_CALL = 'PLEASE_CALL';
exports.PLEASE_CALL = PLEASE_CALL;
var PLUS_SALES_TAXES_ASTERISK = 'PLUS_SALES_TAXES_ASTERISK';
exports.PLUS_SALES_TAXES_ASTERISK = PLUS_SALES_TAXES_ASTERISK;
var PLUS_TAXES_ASTERISK = 'PLUS_TAXES_ASTERISK';
exports.PLUS_TAXES_ASTERISK = PLUS_TAXES_ASTERISK;
var SLASH_MO = 'SLASH_MO';
exports.SLASH_MO = SLASH_MO;
var THE_DEALERSHIP = 'THE_DEALERSHIP';
exports.THE_DEALERSHIP = THE_DEALERSHIP;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.moreDetailsEvent = moreDetailsEvent;
exports.closeDetailsEvent = closeDetailsEvent;
exports.priceDetailsScrollEvent = priceDetailsScrollEvent;
exports.disclaimerDetailsModalEvents = disclaimerDetailsModalEvents;
exports.ePriceButtonTrackEvent = ePriceButtonTrackEvent;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var defaultClickEvent = {
  event: 'widgetUserEvent',
  element: 'More details button',
  elementCTA: 'Details',
  action: 'clicked',
  result: 'Revealed detail information popup',
  widgetName: 'ws-detailed-pricing',
  widgetId: 'detailed-pricing1',
  widgetState: 'default',
  fieldValue: undefined,
  formId: undefined,
  formEventId: undefined,
  value: undefined
};

function trackGoogleAnalyticsEvent(eventData) {
  var trackingObject = {};

  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object') {
    trackingObject = window.jQuery(document) || {};
  }

  if (Object.keys(trackingObject).length > 0) {
    trackingObject.trigger('trackEvent', _objectSpread({}, defaultClickEvent, eventData));
  }
}

function moreDetailsEvent(widgetName, widgetId, elementCTA) {
  var eventData = {
    widgetName: widgetName,
    widgetId: widgetId,
    elementCTA: elementCTA
  };
  trackGoogleAnalyticsEvent(eventData);
}

function closeDetailsEvent(widgetName, widgetId) {
  var eventData = {
    element: 'Close button',
    elementCTA: undefined,
    action: 'clicked',
    result: 'Closed detailed information popup',
    widgetName: widgetName,
    widgetId: widgetId
  };
  trackGoogleAnalyticsEvent(eventData);
}

function priceDetailsScrollEvent(widgetName, widgetId) {
  var eventData = {
    element: 'Price details link',
    elementCTA: 'Pricing Detail',
    result: 'Scrolled to destination',
    widgetName: widgetName,
    widgetId: widgetId
  };
  trackGoogleAnalyticsEvent(eventData);
}

function disclaimerDetailsModalEvents(widgetName, widgetId, modalState) {
  var eventData;

  if (modalState) {
    eventData = {
      element: 'Disclaimer details link',
      elementCTA: undefined,
      result: 'Opened dialog',
      widgetName: widgetName,
      widgetId: widgetId
    };
  } else {
    eventData = {
      element: 'Close button',
      elementCTA: undefined,
      result: 'Closed dialog',
      widgetState: 'Disclaimer dialog',
      widgetName: widgetName,
      widgetId: widgetId
    };
  }

  trackGoogleAnalyticsEvent(eventData);
}

function ePriceButtonTrackEvent(buttonLabel, widgetName, widgetId, openModal) {
  var eventData = {
    element: 'Instant ePrice button',
    elementCTA: buttonLabel,
    result: openModal ? 'Opened dialog' : 'ePrice diplayed',
    widgetName: widgetName,
    widgetId: widgetId
  };
  trackGoogleAnalyticsEvent(eventData);
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUTTON_RESET_CLASSES = exports.DESC = exports.ASC = exports.OFFSET_INTEGRATED_DR_HEIGHT = exports.OFFSET_HEIGHT = exports.NO_PRICE_ITEMS = exports.LEASE = exports.LOAN = exports.DOCK = exports.MODAL = void 0;
var MODAL = 'MODAL';
exports.MODAL = MODAL;
var DOCK = 'DOCK';
exports.DOCK = DOCK;
var LOAN = 'LOAN';
exports.LOAN = LOAN;
var LEASE = 'LEASE';
exports.LEASE = LEASE;
var NO_PRICE_ITEMS = 'No prices were returned from vcda.';
exports.NO_PRICE_ITEMS = NO_PRICE_ITEMS;
var OFFSET_HEIGHT = 66;
exports.OFFSET_HEIGHT = OFFSET_HEIGHT;
var OFFSET_INTEGRATED_DR_HEIGHT = 33;
exports.OFFSET_INTEGRATED_DR_HEIGHT = OFFSET_INTEGRATED_DR_HEIGHT;
var ASC = 'asc';
exports.ASC = ASC;
var DESC = 'desc';
exports.DESC = DESC;
var BUTTON_RESET_CLASSES = 'p-0 text-left bg-transparent border-0';
exports.BUTTON_RESET_CLASSES = BUTTON_RESET_CLASSES;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_DEALER_ADDRESS = exports.SET_WIDGET_INFO = exports.VCDA_ERROR = exports.SET_MODAL = exports.SET_INCENTIVE = exports.SET_PRICING = void 0;
// This file should only contain action type constants.
var SET_PRICING = 'SET_PRICING';
exports.SET_PRICING = SET_PRICING;
var SET_INCENTIVE = 'SET_INCENTIVE';
exports.SET_INCENTIVE = SET_INCENTIVE;
var SET_MODAL = 'SET_MODAL';
exports.SET_MODAL = SET_MODAL;
var VCDA_ERROR = 'VCDA_ERROR';
exports.VCDA_ERROR = VCDA_ERROR;
var SET_WIDGET_INFO = 'SET_WIDGET_INFO';
exports.SET_WIDGET_INFO = SET_WIDGET_INFO;
var SET_DEALER_ADDRESS = 'SET_DEALER_ADDRESS';
exports.SET_DEALER_ADDRESS = SET_DEALER_ADDRESS;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CaDisclaimer = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _common = __webpack_require__(2);

var _labels = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CaDisclaimer = function CaDisclaimer(_ref) {
  var dealerAddress = _ref.dealerAddress,
      isFooter = _ref.isFooter;
  var CAAlternateDisclaimerProvinces = ['AB', 'BC', 'MB', 'ON', 'QC', 'SK'];
  var staticDisclaimerClasses = 'final-price-disclaimer ddc-font-size-xsmall text-muted w-100 ';
  var disclaimerClasses = staticDisclaimerClasses + (isFooter ? 'text-left summary-disclaimer' : 'text-right');
  var disclaimerLabel = _labels.PLUS_TAXES_ASTERISK;

  if (CAAlternateDisclaimerProvinces.includes(dealerAddress.state)) {
    disclaimerLabel = _labels.PLUS_SALES_TAXES_ASTERISK;
  }

  if (dealerAddress.country === 'CA') {
    return _react.default.createElement("div", {
      className: disclaimerClasses
    }, _react.default.createElement(_common.Common, {
      render: function render(_ref2) {
        var labels = _ref2.labels;
        return labels.get(disclaimerLabel);
      }
    }));
  } else {
    return null;
  }
};

exports.CaDisclaimer = CaDisclaimer;
CaDisclaimer.propTypes = {
  dealerAddress: _propTypes.default.shape({
    address1: _propTypes.default.string,
    address2: _propTypes.default.string,
    address3: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    postalCode: _propTypes.default.string,
    country: _propTypes.default.string
  })
};
CaDisclaimer.defaultProps = {
  dealerAddress: {},
  isFooter: false
};
var _default = CaDisclaimer;
exports.default = _default;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LabelAsHTML = function LabelAsHTML(props) {
  var label = props.label,
      isStyleEditable = props.isStyleEditable,
      vehicleTypeClass = props.vehicleTypeClass,
      typeClass = props.typeClass;
  return (
    /* eslint react/no-danger: 0 */
    _react.default.createElement("span", {
      className: "price-label",
      "data-style-editor-id": isStyleEditable ? "vdp-".concat(typeClass, "-price-label") : null,
      "data-style-editor-text": isStyleEditable ? ".vdp .".concat(vehicleTypeClass, ".pricing-detail .").concat(typeClass, " .price-label") : null,
      dangerouslySetInnerHTML: {
        __html: label
      }
    })
  );
};

LabelAsHTML.defaultProps = {
  isStyleEditable: false,
  vehicleTypeClass: '',
  typeClass: ''
};
LabelAsHTML.propTypes = {
  label: _propTypes.default.string.isRequired,
  isStyleEditable: _propTypes.default.bool,
  vehicleTypeClass: _propTypes.default.string,
  typeClass: _propTypes.default.string
};
var _default = LabelAsHTML;
exports.default = _default;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = ReactBootstrap;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = ReactDOM;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = ReactRedux;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _common = __webpack_require__(2);

var _utility = __webpack_require__(3);

var _labels = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DisclaimerContent = function DisclaimerContent(_ref) {
  var dealershipName = _ref.dealershipName,
      disclaimerLabel = _ref.disclaimerLabel,
      placeholderValuesObj = _ref.placeholderValuesObj;
  return _react.default.createElement(_common.Common, {
    render: function render(_ref2) {
      var labels = _ref2.labels;
      var introParagraph = labels.get(_labels.FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE);
      var dealershipText = dealershipName === _labels.THE_DEALERSHIP ? labels.get(_labels.THE_DEALERSHIP) : dealershipName;
      var disclaimerHtml = (0, _utility.replacePlaceholders)(labels.get(disclaimerLabel), _objectSpread({}, placeholderValuesObj, {
        '<%=dealershipName%>': dealershipText
      }));
      /* eslint react/no-danger: 0 */

      return [_react.default.createElement("div", {
        key: "introHtml",
        dangerouslySetInnerHTML: {
          __html: introParagraph
        }
      }), _react.default.createElement("div", {
        key: "disclaimerHtml",
        dangerouslySetInnerHTML: {
          __html: disclaimerHtml
        }
      })];
    }
  });
};

DisclaimerContent.propTypes = {
  dealershipName: _propTypes.default.string.isRequired,
  disclaimerLabel: _propTypes.default.string.isRequired,
  placeholderValuesObj: _propTypes.default.shape().isRequired
};
var _default = DisclaimerContent;
exports.default = _default;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactBootstrap = __webpack_require__(10);

var _common = __webpack_require__(2);

var _DisclaimerContent = _interopRequireDefault(__webpack_require__(13));

var _labels = __webpack_require__(4);

var _utility = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DisclaimersModal = function DisclaimersModal(props) {
  var isModalVisible = props.isModalVisible,
      handleClose = props.handleClose,
      paymentInfo = props.paymentInfo;

  if (!paymentInfo) {
    return null;
  }

  var modalBody = '';
  var title = '';
  var _type = paymentInfo._type,
      dealershipName = paymentInfo.dealershipName;
  var placeholderValuesObj = (0, _utility.getDisclaimerPlaceholderObj)(paymentInfo);

  if (_type === 'LOAN') {
    title = _react.default.createElement(_common.Common, {
      render: function render(_ref) {
        var labels = _ref.labels;
        return labels.get(_labels.EST_FINANCE_DISCLAIMER_HEADING);
      }
    });
    modalBody = _react.default.createElement(_DisclaimerContent.default, {
      placeholderValuesObj: placeholderValuesObj,
      disclaimerLabel: _labels.FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE,
      dealershipName: dealershipName
    });
  }

  if (_type === 'LEASE') {
    title = _react.default.createElement(_common.Common, {
      render: function render(_ref2) {
        var labels = _ref2.labels;
        return labels.get(_labels.EST_LEASE_DISCLAIMER_HEADING);
      }
    });
    modalBody = _react.default.createElement(_DisclaimerContent.default, {
      placeholderValuesObj: placeholderValuesObj,
      disclaimerLabel: _labels.FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE,
      dealershipName: dealershipName
    });
  }

  return _react.default.createElement(_reactBootstrap.Modal, {
    show: isModalVisible,
    onHide: handleClose
  }, _react.default.createElement(_reactBootstrap.Modal.Header, {
    closeButton: true
  }, _react.default.createElement(_reactBootstrap.Modal.Title, {
    className: "text-center"
  }, _react.default.createElement("span", {
    className: "h3 font-weight-bold"
  }, title))), _react.default.createElement(_reactBootstrap.Modal.Body, null, modalBody));
};

DisclaimersModal.defaultProps = {
  paymentInfo: null
};
DisclaimersModal.propTypes = {
  isModalVisible: _propTypes.default.bool.isRequired,
  handleClose: _propTypes.default.func.isRequired,
  paymentInfo: _propTypes.default.shape()
};
var _default = DisclaimersModal;
exports.default = _default;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _common = __webpack_require__(2);

var _DisclaimersModal = _interopRequireDefault(__webpack_require__(14));

var _labels = __webpack_require__(4);

var _constants = __webpack_require__(6);

var _analytics = __webpack_require__(5);

var _utility = __webpack_require__(3);

var _PricingSummaryFinalPrice = _interopRequireDefault(__webpack_require__(30));

var _PricingSummaryPayments = _interopRequireDefault(__webpack_require__(34));

var _PricingSummaryLink = _interopRequireDefault(__webpack_require__(33));

var _CanadaDisclaimerContent = __webpack_require__(8);

__webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var getFormattedValue = function getFormattedValue(formatted) {
  var formattedValue = formatted;

  if (formattedValue === _labels.PLEASE_CALL) {
    formattedValue = _react.default.createElement(_common.Common, {
      render: function render(_ref) {
        var labels = _ref.labels;
        return labels.get(_labels.PLEASE_CALL);
      }
    });
  }

  return formattedValue;
};

var PricingSummaryUpdated =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummaryUpdated, _React$Component);

  function PricingSummaryUpdated(props) {
    var _this;

    _classCallCheck(this, PricingSummaryUpdated);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PricingSummaryUpdated).call(this, props));
    _this.state = {
      isModalVisible: false,
      paymentInfo: null
    };
    _this.closeModal = _this.closeModal.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(PricingSummaryUpdated, [{
    key: "closeModal",
    value: function closeModal() {
      var _this$props$widgetInf = this.props.widgetInfo,
          widgetName = _this$props$widgetInf.widgetName,
          windowId = _this$props$widgetInf.windowId;
      (0, _analytics.disclaimerDetailsModalEvents)(widgetName, windowId, false);
      this.setState({
        isModalVisible: false
      });
    }
  }, {
    key: "handleHelpCircleIcon",
    value: function handleHelpCircleIcon(paymentInfo) {
      var _this$props$widgetInf2 = this.props.widgetInfo,
          widgetName = _this$props$widgetInf2.widgetName,
          windowId = _this$props$widgetInf2.windowId;
      (0, _analytics.disclaimerDetailsModalEvents)(widgetName, windowId, true);
      this.setState({
        isModalVisible: true,
        paymentInfo: paymentInfo
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$summary = _this$props.summary,
          summary = _this$props$summary === void 0 ? [] : _this$props$summary,
          isMobile = _this$props.isMobile,
          viewPriceDetail = _this$props.viewPriceDetail;
      var showStickySidebarLoanLease = this.props.prefs.showStickySidebarLoanLease;
      var finalLabelSize = isMobile ? 'ddc-font-size-base' : 'ddc-font-size-small';
      var finalPriceSize = isMobile ? 'ddc-font-size-xxlarge' : 'ddc-font-size-xlarge';
      var paymentLabelSize = isMobile ? 'ddc-font-size-small' : 'ddc-font-size-xsmall';
      var paymentPriceSize = isMobile ? 'ddc-font-size-xlarge' : 'ddc-font-size-large';
      var summaryLength = summary.length;
      var pricingSummary;

      if (summaryLength === 0) {
        return null;
      } else if (summaryLength > 1 && showStickySidebarLoanLease === 'true') {
        var finalPriceSummary = (0, _utility.filterFinal)(summary);
        var paymentsSummary = (0, _utility.filterLoanLease)(summary);
        pricingSummary = _react.default.createElement("div", null, _react.default.createElement(_DisclaimersModal.default, {
          isModalVisible: this.state.isModalVisible,
          handleClose: this.closeModal,
          paymentInfo: this.state.paymentInfo
        }), _react.default.createElement("ul", {
          className: "pricing-summary list-unstyled d-flex align-items-end justify-items-between mb-4"
        }, _react.default.createElement("li", {
          className: (0, _utility.setClassNames)(summaryLength <= 2 ? 'half-width' : 'third-width', ' d-flex', 'flex-wrap', 'mr-4', 'summary-price')
        }, finalPriceSummary.map(function (price) {
          return _react.default.createElement(_PricingSummaryFinalPrice.default, _extends({
            price: price,
            viewPriceDetail: viewPriceDetail,
            finalLabelSize: finalLabelSize,
            finalPriceSize: finalPriceSize,
            paymentLabelSize: paymentLabelSize
          }, {
            key: price._type,
            buttonResetClasses: _constants.BUTTON_RESET_CLASSES,
            finalPrice: getFormattedValue(price.formatted)
          }));
        }), _react.default.createElement(_PricingSummaryLink.default, {
          label: _labels.DETAILED_PRICING,
          labelFontSize: paymentLabelSize,
          isCalculatePayment: false,
          viewPriceDetail: viewPriceDetail
        })), _react.default.createElement("li", {
          className: "d-flex flex-wrap flex-grow-1"
        }, paymentsSummary.map(function (price) {
          return _react.default.createElement(_PricingSummaryPayments.default, _extends({
            price: price,
            paymentLabelSize: paymentLabelSize,
            paymentPriceSize: paymentPriceSize
          }, {
            key: price._type,
            paymentPrice: getFormattedValue(price.formatted),
            handleHelpCircleIcon: function handleHelpCircleIcon() {
              return _this2.handleHelpCircleIcon(price);
            }
          }));
        }), _react.default.createElement(_PricingSummaryLink.default, {
          label: _labels.CUSTOMIZE_PAYMENTS,
          labelFontSize: paymentLabelSize,
          isCalculatePayment: true
        }))));
      } else {
        // single item (final price) will get detailed pricing markup
        // summary[0] will always be final price - ref: VCDApricing.js
        var _summary$ = summary[0],
            label = _summary$.label,
            formatted = _summary$.formatted;
        var dealerAddress = this.props.dealerAddress;
        pricingSummary = _react.default.createElement("dl", {
          className: "pricing-detail final-price line-height-condensed mb-4"
        }, _react.default.createElement("dt", null, _react.default.createElement("button", {
          className: _constants.BUTTON_RESET_CLASSES,
          onClick: viewPriceDetail
        }, _react.default.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: label
          }
        }), _react.default.createElement(_PricingSummaryLink.default, {
          label: _labels.DETAILED_PRICING,
          labelFontSize: paymentLabelSize
        }))), _react.default.createElement("dd", {
          className: (0, _utility.setClassNames)('font-weight-bold', finalPriceSize)
        }, _react.default.createElement("button", {
          className: _constants.BUTTON_RESET_CLASSES,
          onClick: viewPriceDetail
        }, getFormattedValue(formatted))), _react.default.createElement(_CanadaDisclaimerContent.CaDisclaimer, {
          dealerAddress: dealerAddress
        }));
      }

      return pricingSummary;
    }
  }]);

  return PricingSummaryUpdated;
}(_react.default.Component);

exports.default = PricingSummaryUpdated;
PricingSummaryUpdated.propTypes = {
  prefs: _propTypes.default.shape({
    showStickySidebarLoanLease: _propTypes.default.string
  }).isRequired,
  summary: _propTypes.default.arrayOf(_propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired
  })).isRequired,
  viewPriceDetail: _propTypes.default.func.isRequired,
  widgetInfo: _propTypes.default.shape({
    windowId: _propTypes.default.string.isRequired,
    widgetName: _propTypes.default.string.isRequired,
    deviceType: _propTypes.default.string.isRequired
  }).isRequired,
  dealerAddress: _propTypes.default.shape({
    address1: _propTypes.default.string,
    address2: _propTypes.default.string,
    address3: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    postalCode: _propTypes.default.string,
    country: _propTypes.default.string
  }),
  isMobile: _propTypes.default.bool
};
PricingSummaryUpdated.defaultProps = {
  dealerAddress: {},
  isMobile: false
};

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.7.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseGet = __webpack_require__(57),
    toPath = __webpack_require__(59);

/**
 * Gets the property value of `path` on `object`. If the resolved value is
 * `undefined` the `defaultValue` is used in its place.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Dock = __webpack_require__(64);

var _Dock2 = _interopRequireDefault(_Dock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Dock2.default;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(11);

var _reactHotLoader = __webpack_require__(66);

var _Widget = _interopRequireDefault(__webpack_require__(37));

var _store = __webpack_require__(52);

var _widgetComponents = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * WARNING: This file is owned by ws-scripts and can not be edited!
 *
 * This is the main entry point for our application when
 * executed in the browser. As such, it has some responsibilities:
 *
 * - Load server side rendered redux state
 * - Create the redux store with that state
 * - Kick off a React render bound to the redux store
 *
 * NOTE: The eslint-disable-lines are needed because this file won't lint
 * when it's in the ws-scripts repo because those files only exist in the
 * widget. It's safe because the entire application won't work if those
 * weren't really resolved. It would be really apparent quickly.
 *
 * We load our server side rendered state from an object
 * of the form:
 *
 *	window.DDC = {
 *		OSIRIS: {
 *			state: {
 *				"ws-hours": {
 *					"hours1": {STATE}
 *					"hours2": {STATE}
 *				},
 *				"ws-quick-specs": {
 *					"quick-specs1": {STATE}
 *				}
 *			}
 *		}
 *	};
 *
 * In local development, the state will be a JSON object. When
 * loaded from CMS, it will be a string, since that reduces
 * serialization overhead but still avoids string concatenation.
 */
// eslint-disable-line import/no-unresolved
var getWidgetStatesByType = function getWidgetStatesByType(widgetName) {
  if (!window.DDC || !window.DDC.OSIRIS || !window.DDC.OSIRIS.state || !window.DDC.OSIRIS.state[widgetName]) {
    return {};
  }

  return window.DDC.OSIRIS.state[widgetName];
};

var getWidgetState = function getWidgetState(widgetStates, widgetId) {
  var preloadedState = widgetStates[widgetId];

  if (typeof preloadedState === 'string') {
    preloadedState = JSON.parse(preloadedState);
  }

  return preloadedState;
};

var renderWidget = function renderWidget(WidgetComponent, renderFunc, store, widgetId) {
  renderFunc(_react.default.createElement(_reactHotLoader.AppContainer, null, (0, _widgetComponents.getWidgetComponents)(WidgetComponent, store, widgetId)), document.getElementById("".concat(widgetId, "-app-root")));
};

var widgetIdToStore = {};

var initializeWidgets = function initializeWidgets() {
  var widgetStates = getWidgetStatesByType('ws-detailed-pricing');
  var widgetIds = Object.keys(widgetStates);
  widgetIds.forEach(function (widgetId) {
    var store = (0, _store.createStore)(getWidgetState(widgetStates, widgetId));
    widgetIdToStore[widgetId] = store;
    renderWidget(_Widget.default, _reactDom.hydrate, store, widgetId);
  });
};

if (window.DDC && window.DDC.Events && window.DDC.Events['inline-js-available']) {
  initializeWidgets();
} else {
  $(document).on('inlineJSAvailable', initializeWidgets);
}

if (false) {
  module.hot.accept('../containers/Widget', function () {
    Object.keys(widgetIdToStore).forEach(function (widgetId) {
      var store = widgetIdToStore[widgetId];

      var ReloadedWidget = require('../containers/Widget').default; // eslint-disable-line import/no-unresolved


      renderWidget(ReloadedWidget, _reactDom.render, store, widgetId);
    });
  });
}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDock = _interopRequireDefault(__webpack_require__(18));

var _common = __webpack_require__(2);

var _analytics = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var IncentiveDock =
/*#__PURE__*/
function (_React$Component) {
  _inherits(IncentiveDock, _React$Component);

  function IncentiveDock(props) {
    var _this;

    _classCallCheck(this, IncentiveDock);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(IncentiveDock).call(this, props));
    _this.close = _this.close.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(IncentiveDock, [{
    key: "close",
    value: function close() {
      var _this$props$widgetInf = this.props.widgetInfo,
          windowId = _this$props$widgetInf.windowId,
          widgetName = _this$props$widgetInf.widgetName;
      (0, _analytics.closeDetailsEvent)(widgetName, windowId);
      this.props.setModalStateData({}, false);
    }
  }, {
    key: "render",
    value: function render() {
      var isModalVisible = this.props.isModalVisible;
      var _this$props$incentive = this.props.incentive,
          error = _this$props$incentive.error,
          disclaimer = _this$props$incentive.disclaimer,
          title = _this$props$incentive.title,
          conditional = _this$props$incentive.conditional,
          offerDetails = _this$props$incentive.offerDetails,
          effectiveDate = _this$props$incentive.effectiveDate,
          expirationDate = _this$props$incentive.expirationDate;
      var dialogBody;
      var incentiveDisclaimer = '';

      var closeButton = _react.default.createElement("button", {
        type: "button",
        "aria-label": "Close",
        className: "close text-muted font-weight-bold ",
        onClick: this.close
      }, _react.default.createElement("i", {
        className: "ddc-icon ddc-icon-close",
        "aria-hidden": "true"
      }));

      if (error) {
        dialogBody = _react.default.createElement("div", null, _react.default.createElement("h4", null, "Error: unable to render incentive data"), _react.default.createElement("p", null, error));
      } else {
        if (disclaimer) {
          incentiveDisclaimer = _react.default.createElement(_common.Common, {
            render: function render(_ref) {
              var labels = _ref.labels;
              return _react.default.createElement("div", {
                className: "text-muted mt-4"
              }, _react.default.createElement("h4", null, labels.get('DISCLAIMER')), _react.default.createElement("p", null, disclaimer));
            }
          });
        }

        dialogBody = _react.default.createElement(_common.Common, {
          render: function render(_ref2) {
            var labels = _ref2.labels;
            var offer;

            if (conditional) {
              offer = labels.get('DEALER_OFFER');
            } else {
              offer = labels.get('MANUFACTURER_OFFER');
            }

            return _react.default.createElement("div", {
              className: "border-top"
            }, _react.default.createElement("h4", {
              className: "text-muted mt-4 mb-0"
            }, offer), _react.default.createElement("h2", {
              className: "mt-0"
            }, title), _react.default.createElement("p", null, _react.default.createElement("span", {
              className: "d-block"
            }, offerDetails), _react.default.createElement("span", {
              className: "d-block"
            }, labels.get('OFFER_VALID'), ' ', effectiveDate, " ", labels.get('THROUGH'), ' ', expirationDate)), incentiveDisclaimer);
          }
        });
      }

      var dialogHeader = _react.default.createElement(_common.Common, {
        render: function render(_ref3) {
          var labels = _ref3.labels;
          return _react.default.createElement("div", {
            className: "mt-4 mb-5"
          }, closeButton, _react.default.createElement("div", {
            className: "text-center"
          }, _react.default.createElement("h4", null, labels.get('VEHICLE_INCENTIVE'))));
        }
      });

      var dock = null;

      if (isModalVisible) {
        var isFluid = true;
        var position = 'right';
        var size = 0.9;
        var duration = 2000;
        dock = _react.default.createElement(_reactDock.default, {
          isVisible: isModalVisible,
          position: position,
          size: size,
          fluid: isFluid,
          duration: duration,
          onVisibleChange: this.close
        }, _react.default.createElement("div", {
          className: "m-3"
        }, dialogHeader, dialogBody));
      }

      return _react.default.createElement("div", null, dock);
    }
  }]);

  return IncentiveDock;
}(_react.default.Component);

exports.default = IncentiveDock;
IncentiveDock.propTypes = {
  incentive: _propTypes.default.shape({
    key: _propTypes.default.string,
    title: _propTypes.default.string,
    label: _propTypes.default.string,
    offerDetails: _propTypes.default.string,
    shortTitle: _propTypes.default.string,
    disclaimer: _propTypes.default.string,
    effectiveDate: _propTypes.default.string,
    expirationDate: _propTypes.default.string,
    conditional: _propTypes.default.bool,
    error: _propTypes.default.string
  }).isRequired,
  isModalVisible: _propTypes.default.bool.isRequired,
  setModalStateData: _propTypes.default.func.isRequired,
  widgetInfo: _propTypes.default.shape({
    windowId: _propTypes.default.string.isRequired,
    widgetName: _propTypes.default.string.isRequired
  }).isRequired
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactBootstrap = __webpack_require__(10);

var _common = __webpack_require__(2);

var _analytics = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var IncentiveModal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(IncentiveModal, _React$Component);

  function IncentiveModal(props) {
    var _this;

    _classCallCheck(this, IncentiveModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(IncentiveModal).call(this, props));
    _this.close = _this.close.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(IncentiveModal, [{
    key: "close",
    value: function close() {
      var _this$props$widgetInf = this.props.widgetInfo,
          windowId = _this$props$widgetInf.windowId,
          widgetName = _this$props$widgetInf.widgetName;
      (0, _analytics.closeDetailsEvent)(widgetName, windowId);
      this.props.setModalStateData({}, false);
    }
  }, {
    key: "render",
    value: function render() {
      var isModalVisible = this.props.isModalVisible;
      var _this$props$incentive = this.props.incentive,
          error = _this$props$incentive.error,
          disclaimer = _this$props$incentive.disclaimer,
          conditional = _this$props$incentive.conditional,
          title = _this$props$incentive.title,
          offerDetails = _this$props$incentive.offerDetails,
          effectiveDate = _this$props$incentive.effectiveDate,
          expirationDate = _this$props$incentive.expirationDate;
      var dialogTitle;
      var dialogBody;

      if (error) {
        dialogTitle = 'Error: unable to render incentive data';
        dialogBody = _react.default.createElement("p", null, error);
      } else {
        dialogTitle = _react.default.createElement(_common.Common, {
          render: function render(_ref) {
            var labels = _ref.labels;
            return _react.default.createElement("span", {
              className: "h3 font-weight-bold"
            }, labels.get('VEHICLE_INCENTIVE'));
          }
        });
        var incentiveDisclaimer = '';

        if (disclaimer) {
          incentiveDisclaimer = _react.default.createElement(_common.Common, {
            render: function render(_ref2) {
              var labels = _ref2.labels;
              return _react.default.createElement("div", {
                className: "text-muted mt-4"
              }, _react.default.createElement("h4", null, labels.get('DISCLAIMER')), _react.default.createElement("p", null, disclaimer));
            }
          });
        }

        dialogBody = _react.default.createElement(_common.Common, {
          render: function render(_ref3) {
            var labels = _ref3.labels;
            var offer;

            if (conditional) {
              offer = labels.getHTML('DEALER_OFFER');
            } else {
              offer = labels.getHTML('MANUFACTURER_OFFER');
            }

            return _react.default.createElement("div", null, _react.default.createElement("h4", {
              className: "text-muted mt-2 mb-0"
            }, offer), _react.default.createElement("h2", {
              className: "mt-0"
            }, title), _react.default.createElement("p", null, _react.default.createElement("span", {
              className: "d-block"
            }, offerDetails), _react.default.createElement("span", {
              className: "d-block"
            }, labels.get('OFFER_VALID'), ' ', effectiveDate, " ", labels.get('THROUGH'), ' ', expirationDate)), incentiveDisclaimer);
          }
        });
      }

      return _react.default.createElement("div", null, _react.default.createElement(_reactBootstrap.Modal, {
        show: isModalVisible,
        onHide: this.close
      }, _react.default.createElement("div", {
        className: "m-1"
      }, _react.default.createElement(_reactBootstrap.Modal.Header, {
        closeButton: true
      }, _react.default.createElement(_reactBootstrap.Modal.Title, {
        className: "text-center"
      }, dialogTitle)), _react.default.createElement(_reactBootstrap.Modal.Body, null, dialogBody))));
    }
  }]);

  return IncentiveModal;
}(_react.default.Component);

exports.default = IncentiveModal;
IncentiveModal.propTypes = {
  incentive: _propTypes.default.shape({
    key: _propTypes.default.string,
    title: _propTypes.default.string,
    label: _propTypes.default.string,
    offerDetails: _propTypes.default.string,
    shortTitle: _propTypes.default.string,
    disclaimer: _propTypes.default.string,
    effectiveDate: _propTypes.default.string,
    expirationDate: _propTypes.default.string,
    conditional: _propTypes.default.bool,
    error: _propTypes.default.string
  }).isRequired,
  isModalVisible: _propTypes.default.bool.isRequired,
  setModalStateData: _propTypes.default.func.isRequired,
  widgetInfo: _propTypes.default.shape({
    windowId: _propTypes.default.string.isRequired,
    widgetName: _propTypes.default.string.isRequired
  }).isRequired
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactBootstrap = __webpack_require__(10);

var _common = __webpack_require__(2);

var _utility = __webpack_require__(3);

var _labels = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InstantEPriceButton = function InstantEPriceButton(props) {
  var isModalVisible = props.isModalVisible,
      loadingUserProfile = props.loadingUserProfile,
      userLoggedIn = props.userLoggedIn,
      handleClick = props.handleClick,
      buttonLabel = props.buttonLabel,
      pendingLabel = props.pendingLabel,
      vehicleId = props.vehicleId,
      vehicleCategory = props.vehicleCategory,
      pageAlias = props.pageAlias,
      buttonStyle = props.buttonStyle,
      buttonMobileClass = props.buttonMobileClass,
      disabled = props.disabled,
      preventMultipleEpriceLeads = props.preventMultipleEpriceLeads;
  var formUrl = "/instant-eprice-form.htm?itemId=".concat(vehicleId, "&vehicleId=").concat(vehicleId, "&category=").concat(vehicleCategory) + "&parentPageAlias=".concat(pageAlias, "&vcdaInstantEPrice");

  var allowLeadSubmission = function allowLeadSubmission() {
    // Don't submit a lead if preventMultipleEpriceLeads preference is set and user
    // has already submitted one
    return !(preventMultipleEpriceLeads && window.DDC.userProfile.ePriceVehicles && window.DDC.userProfileController.hasUserContactData());
  };

  var submitLeadConditionally = function submitLeadConditionally() {
    if (allowLeadSubmission()) {
      window.DDC.userProfileController.sendLeadForm(formUrl);
    }
  };

  var openModalOrSubmitLead = function openModalOrSubmitLead() {
    try {
      handleClick();
    } catch (error) {
      throw new Error('Unable to handle click.');
    } finally {
      submitLeadConditionally();
    }
  };

  var nonModalLogIn = userLoggedIn && !isModalVisible;
  var dataHrefAttr = nonModalLogIn ? null : formUrl; // if the user is logged in, we don't want to trigger a dialog in mobile (slide-in) or desktop (modal)

  var dialogClass = nonModalLogIn ? 'slidein-disabled' : 'dialog';
  var buttonDisplayClass = isModalVisible ? 'd-none' : '';
  var modalDisplayClass = isModalVisible ? '' : 'd-none';
  var spinningGears = loadingUserProfile ? _react.default.createElement("i", {
    className: "mr-3 ddc-icon ddc-icon-loading ddc-icon-animate-spin"
  }) : null;
  var buttonAllClassNames = (0, _utility.setClassNames)('btn-block', 'btn', "btn-".concat(buttonStyle), 'instant-eprice', "".concat(dialogClass), "".concat(buttonDisplayClass));
  var pendingLabelClassNames = (0, _utility.setClassNames)('instanteprice-pending', 'font-weight-bold', 'text-success', 'text-center', "".concat(modalDisplayClass));

  var tooltip = _react.default.createElement(_reactBootstrap.Tooltip, {
    className: "tooltip",
    id: "tooltip",
    style: {
      color: 'red'
    }
  }, _react.default.createElement(_common.Common, {
    render: function render(_ref) {
      var labels = _ref.labels;
      return labels.get(_labels.INSTANT_EPRICE_DISABLED_POPOVER);
    }
  }));

  var disabledButton = _react.default.createElement("div", {
    className: "disabled"
  }, _react.default.createElement(_reactBootstrap.OverlayTrigger, {
    placement: "left",
    overlay: tooltip,
    trigger: ['hover', 'click']
  }, _react.default.createElement("div", {
    key: "epriceButtonContainer",
    className: "instantEPriceButton mb-sm-4 ".concat(buttonMobileClass)
  }, _react.default.createElement("button", {
    className: buttonAllClassNames,
    "data-width": "600px",
    disabled: true
  }, buttonLabel))));

  var regularButton = _react.default.createElement("div", null, _react.default.createElement("div", {
    key: "epriceButtonContainer",
    className: "instantEPriceButton mb-sm-4 ".concat(buttonMobileClass)
  }, _react.default.createElement("button", {
    className: buttonAllClassNames,
    onClick: openModalOrSubmitLead,
    rel: "nofollow",
    "data-vehicle-uuid": vehicleId,
    "data-href": dataHrefAttr,
    "data-width": "600px"
  }, spinningGears, buttonLabel), _react.default.createElement("div", {
    key: "label",
    className: pendingLabelClassNames
  }, pendingLabel)));

  return disabled ? disabledButton : regularButton;
};

InstantEPriceButton.propTypes = {
  isModalVisible: _propTypes.default.bool.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  loadingUserProfile: _propTypes.default.bool.isRequired,
  userLoggedIn: _propTypes.default.bool.isRequired,
  buttonLabel: _propTypes.default.string.isRequired,
  pendingLabel: _propTypes.default.string.isRequired,
  handleClick: _propTypes.default.func.isRequired,
  vehicleId: _propTypes.default.string.isRequired,
  vehicleCategory: _propTypes.default.string.isRequired,
  pageAlias: _propTypes.default.string.isRequired,
  buttonStyle: _propTypes.default.string.isRequired,
  buttonMobileClass: _propTypes.default.string.isRequired,
  preventMultipleEpriceLeads: _propTypes.default.bool.isRequired
};
var _default = InstantEPriceButton;
exports.default = _default;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ModalDock = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactBootstrap = __webpack_require__(10);

var _reactDock = _interopRequireDefault(__webpack_require__(18));

var _constants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ModalDock = function ModalDock(_ref) {
  var options = _extends({}, _ref);

  var showState = options.showState,
      closeMethod = options.closeMethod,
      title = options.title,
      body = options.body,
      display = options.display,
      _options$isFluid = options.isFluid,
      isFluid = _options$isFluid === void 0 ? true : _options$isFluid,
      _options$position = options.position,
      position = _options$position === void 0 ? 'right' : _options$position,
      _options$size = options.size,
      size = _options$size === void 0 ? 0.8 : _options$size,
      _options$duration = options.duration,
      duration = _options$duration === void 0 ? 500 : _options$duration;

  if (display === _constants.MODAL) {
    return _react.default.createElement(_reactBootstrap.Modal, {
      show: showState,
      onHide: function onHide() {
        return closeMethod();
      }
    }, _react.default.createElement("div", {
      className: "m-1"
    }, _react.default.createElement(_reactBootstrap.Modal.Header, {
      closeButton: true
    }, _react.default.createElement(_reactBootstrap.Modal.Title, {
      className: "text-center"
    }, _react.default.createElement("span", {
      className: "h3 font-weight-bold"
    }, title))), _react.default.createElement(_reactBootstrap.Modal.Body, null, body)));
  } else if (showState) {
    var closeButton = _react.default.createElement("button", {
      type: "button",
      "aria-label": "Close",
      className: "close text-muted font-weight-bold ",
      onClick: function onClick() {
        return closeMethod();
      }
    }, _react.default.createElement("i", {
      className: "ddc-icon ddc-icon-close",
      "aria-hidden": "true"
    }));

    var dockHeader = _react.default.createElement("div", {
      className: "my-4"
    }, closeButton, _react.default.createElement("div", {
      className: "text-center"
    }, _react.default.createElement("h4", null, title)));

    var dockerBody = _react.default.createElement("div", {
      className: "border-top pt-4"
    }, body);

    return _react.default.createElement(_reactDock.default, {
      isVisible: showState,
      position: position,
      size: size,
      fluid: isFluid,
      duration: duration,
      onVisibleChange: function onVisibleChange() {
        return closeMethod();
      }
    }, _react.default.createElement("div", {
      className: "m-3"
    }, _react.default.createElement("div", null, dockHeader), _react.default.createElement("div", null, dockerBody)));
  } else {
    return null;
  }
};

exports.ModalDock = ModalDock;
ModalDock.propTypes = {
  showState: _propTypes.default.bool.isRequired,
  closeMethod: _propTypes.default.func.isRequired,
  title: _propTypes.default.element.isRequired,
  body: _propTypes.default.element.isRequired,
  display: _propTypes.default.string.isRequired
};
var _default = ModalDock;
exports.default = _default;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PaymentCalculatorButton = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _lodash = _interopRequireDefault(__webpack_require__(17));

var _constants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentCalculatorButton = function PaymentCalculatorButton(_ref) {
  var isLoanLeaseAvailable = _ref.isLoanLeaseAvailable,
      isScrollingSidebar = _ref.isScrollingSidebar,
      isMobile = _ref.isMobile,
      prefs = _ref.prefs,
      labels = _ref.labels;

  var handleButtonClick = function handleButtonClick() {
    if (isMobile) {
      var pubsub = (0, _lodash.default)(window, 'pubsub', undefined);

      if (pubsub) {
        pubsub.publish('openDRTools', 'payment');
        return;
      }
    }

    var headerSelector = document && document.querySelector('[data-widget-id="template-navigation1"]');
    var scrollToSelector = '[data-widget-id="digital-retailing-1"]';
    var pageHeaderHeight = headerSelector && headerSelector.clientHeight || 0;
    /* eslint no-undef: 0 */

    if (DDC && DDC.scrollToAnchor) {
      DDC.scrollToAnchor($(scrollToSelector), {
        heightAdj: pageHeaderHeight + _constants.OFFSET_INTEGRATED_DR_HEIGHT
      });
    }
  };

  var renderButton = function renderButton() {
    var paymentCalculatorButtonLabel = prefs.paymentCalculatorButtonLabel,
        paymentCalculatorButtonClasses = prefs.paymentCalculatorButtonClasses,
        paymentCalculatorButtonIcon = prefs.paymentCalculatorButtonIcon,
        paymentCalculatorButtonIconClasses = prefs.paymentCalculatorButtonIconClasses,
        paymentBoxBackground = prefs.paymentBoxBackground,
        paymentBoxPadding = prefs.paymentBoxPadding;
    var buttonWrapperClasses = ["py-".concat(paymentBoxPadding)];

    if (!isScrollingSidebar) {
      var applyBoxPadding;
      var applyBoxBackground;
      var bottomPaddingClasses = "pb-".concat(paymentBoxPadding);

      if (isLoanLeaseAvailable) {
        applyBoxPadding = "px-".concat(paymentBoxPadding);
        applyBoxBackground = paymentBoxBackground;
      }

      buttonWrapperClasses = ['payment-calculator-wrapper', applyBoxBackground, applyBoxPadding, bottomPaddingClasses];
    }

    return _react.default.createElement("div", null, _react.default.createElement("div", {
      className: buttonWrapperClasses.filter(Boolean).join(' ')
    }, _react.default.createElement("button", {
      className: "btn btn-".concat(paymentCalculatorButtonClasses, " w-100"),
      onClick: handleButtonClick
    }, _react.default.createElement("i", {
      className: "ddc-icon ddc-icon-".concat(paymentCalculatorButtonIcon, " ").concat(paymentCalculatorButtonIconClasses)
    }), labels.get(paymentCalculatorButtonLabel))));
  };

  return renderButton();
};

exports.PaymentCalculatorButton = PaymentCalculatorButton;
PaymentCalculatorButton.propTypes = {
  isLoanLeaseAvailable: _propTypes.default.bool.isRequired,
  isScrollingSidebar: _propTypes.default.bool.isRequired,
  isMobile: _propTypes.default.bool.isRequired,
  prefs: _propTypes.default.shape({
    paymentCalculatorButtonLabel: _propTypes.default.string,
    paymentCalculatorButtonClasses: _propTypes.default.string,
    paymentCalculatorButtonIcon: _propTypes.default.string,
    paymentCalculatorButtonIconClasses: _propTypes.default.string,
    paymentBoxBackground: _propTypes.default.string,
    paymentBoxPadding: _propTypes.default.string
  }).isRequired,
  labels: _propTypes.default.shape({
    get: _propTypes.default.func.isRequired
  }).isRequired
};
var _default = PaymentCalculatorButton;
exports.default = _default;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _common = __webpack_require__(2);

var _LabelAsHTML = _interopRequireDefault(__webpack_require__(9));

var _analytics = __webpack_require__(5);

var _utility = __webpack_require__(3);

var _CanadaDisclaimerContent = __webpack_require__(8);

var _labels = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PricingDetail =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingDetail, _React$Component);

  function PricingDetail() {
    _classCallCheck(this, PricingDetail);

    return _possibleConstructorReturn(this, _getPrototypeOf(PricingDetail).apply(this, arguments));
  }

  _createClass(PricingDetail, [{
    key: "showModal",
    value: function showModal(incentiveId) {
      var incentiveData = this.props.incentiveData;
      var incentiveDetails = incentiveData.find(function (incentive) {
        return incentive.key === incentiveId;
      });
      var _this$props$widgetInf = this.props.widgetInfo,
          windowId = _this$props$widgetInf.windowId,
          widgetName = _this$props$widgetInf.widgetName;
      (0, _analytics.moreDetailsEvent)(widgetName, windowId, 'Details');
      this.props.setModalStateData(incentiveDetails, true);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          detail = _this$props.detail,
          detailType = _this$props.detailType,
          _this$props$prefs = _this$props.prefs,
          priceDiscountColor = _this$props$prefs.priceDiscountColor,
          finalPriceSize = _this$props$prefs.finalPriceSize,
          finalPriceColor = _this$props$prefs.finalPriceColor,
          locale = _this$props.locale,
          dealerAddress = _this$props.dealerAddress,
          isFinalPriceFlagEnabled = _this$props.isFinalPriceFlagEnabled;
      var _this$props$widgetInf2 = this.props.widgetInfo,
          deviceType = _this$props$widgetInf2.deviceType,
          vehicleType = _this$props$widgetInf2.vehicleType;
      var isMobile = deviceType === 'MOBILE';
      var adjustmentDetected = false;
      var vehicleTypeClass = vehicleType ? "inv-type-".concat(vehicleType.toLowerCase()) : '';
      return _react.default.createElement("dl", {
        className: (0, _utility.setClassNames)('pricing-detail', 'line-height-condensed', 'mb-4', vehicleTypeClass)
      }, detail.map(function (price) {
        var _type = price._type,
            incentiveId = price.incentiveId,
            formatted = price.formatted,
            isFinalPrice = price.isFinalPrice,
            shortLabel = price.shortLabel,
            showCategory = price.showCategory;
        var typeClass = price.typeClass;
        var formattedValue = formatted;
        var valueClass = '';

        if (formattedValue === _labels.PLEASE_CALL) {
          valueClass = 'no-value';
          formattedValue = _react.default.createElement(_common.Common, {
            render: function render(_ref) {
              var labels = _ref.labels;
              return labels.get(_labels.PLEASE_CALL);
            }
          });
        }

        var isStackedFinal = _type === 'SICF' || _type === 'SIF';
        var isPlusMinus = _type === '-' || _type === '+';
        var isSubtractedTypes = ['-', // Discount
        'SICI', // Stack Itemized Cash Incentive
        'SICCI', // Stack Itemized Conditional Cash Incentive
        'SICNI', // Stack non-Itemized Cash Incentives
        'SICCNI', // Stack non-Itemized Conditional Cash Incentive
        'CCIC' // Conditional Category Incentive Cash
        ];
        var isSubtracted = isSubtractedTypes.includes(_type);
        var isTotal = _type === 'TOTAL' || // Represents the last price in the rule
        _type === 'SICF' || // Final price including conditional incentives
        _type === 'SIF' || // Final price including stack incentives
        isFinalPrice;
        var isEpriceFinal; // Remove when removing flag

        if (isFinalPriceFlagEnabled) {
          // Keep the next line when removing flag and make isEpriceFinal a const
          isEpriceFinal = detailType === 'ePrice' && _type === 'TOTAL';
        } else {
          isEpriceFinal = detailType === 'ePrice' && isFinalPrice;
        }

        var isIncentive = !!incentiveId;

        var incentiveLinkMarkup = _react.default.createElement("button", {
          className: (0, _utility.setClassNames)('text-link', 'd-block', isMobile ? 'ddc-font-size-small' : 'ddc-font-size-xsmall')
        }, _react.default.createElement(_common.Common, {
          render: function render(_ref2) {
            var labels = _ref2.labels;
            return labels.get(_labels.DETAILS);
          }
        }));

        var lineBreakMarkup = _react.default.createElement("dd", {
          className: "pricing-divider my-3",
          key: "".concat(_type, "-divider")
        });

        var hasLineBreak = false;
        var subtractedValueClass = '';
        var totalValueClass = '';
        var ePriceClass = '';
        var formattedPrice = formattedValue;
        var canadaDisclaimerMarkup = null;

        if (isStackedFinal) {
          hasLineBreak = true;
        }

        if (isPlusMinus) {
          adjustmentDetected = true;
          hasLineBreak = false;
        } else {
          if (adjustmentDetected === true) {
            hasLineBreak = true;
          }

          adjustmentDetected = false;
        }

        if (isSubtracted) {
          if (formatted === _labels.PLEASE_CALL) {
            formattedPrice = formattedValue;
          } else {
            formattedPrice = isMobile ? "- ".concat(formattedValue) : "-".concat(formattedValue);
            subtractedValueClass = "".concat(priceDiscountColor);
          }
        }

        if (isTotal) {
          totalValueClass = 'font-weight-bold';
        }

        if (isEpriceFinal) {
          ePriceClass = 'eprice';
        }

        if (isFinalPrice) {
          typeClass = 'final-price';
          totalValueClass = "".concat(totalValueClass, " ").concat(finalPriceColor); // suppressing finalPriceSize for final pricing that contains PLEASE_CALL value

          if (formatted !== _labels.PLEASE_CALL) {
            totalValueClass = "".concat(totalValueClass, " ").concat(finalPriceSize);
            canadaDisclaimerMarkup = _react.default.createElement(_CanadaDisclaimerContent.CaDisclaimer, {
              dealerAddress: dealerAddress
            });
          }
        }

        var isStyleEditable = vehicleTypeClass !== '' && typeClass !== '';
        return [hasLineBreak ? lineBreakMarkup : '', _react.default.createElement("dt", {
          "data-style-editor-price": isStyleEditable ? 'true' : null,
          className: (0, _utility.setClassNames)(isIncentive ? 'pointer' : '', isStyleEditable ? typeClass : ''),
          onClick: function onClick() {
            return isIncentive ? _this.showModal(incentiveId) : false;
          },
          key: "".concat(_type, "-dt")
        }, _react.default.createElement(_common.Common, {
          render: function render(_ref3) {
            var prefs = _ref3.prefs,
                labels = _ref3.labels,
                flags = _ref3.flags;
            var label; // TODO: restore tests in PricingDetail.test.jsx after this flag is removed

            if (flags['ws-detailed-pricing-show-alternate-incentive-titles']) {
              label = PricingDetail.getLabel({
                price: price,
                prefs: prefs,
                labels: labels,
                locale: locale
              });
            } else {
              // conditional for setting label.
              label = shortLabel && showCategory === true && shortLabel[locale] ? shortLabel[locale] : price.label;
            }

            return _react.default.createElement(_LabelAsHTML.default, {
              label: label,
              isStyleEditable: isStyleEditable,
              typeClass: typeClass,
              vehicleTypeClass: vehicleTypeClass
            });
          }
        }), isIncentive ? incentiveLinkMarkup : ''), _react.default.createElement("dd", {
          "data-style-editor-price": isStyleEditable ? 'true' : null,
          onClick: function onClick() {
            return isIncentive ? _this.showModal(incentiveId) : false;
          },
          className: (0, _utility.setClassNames)(subtractedValueClass, totalValueClass, ePriceClass, isIncentive ? 'pointer' : '', isStyleEditable ? typeClass : ''),
          key: "".concat(_type, "-dd")
        }, _react.default.createElement("span", {
          className: (0, _utility.setClassNames)('price-value', valueClass),
          "data-style-editor-id": isStyleEditable ? "vdp-".concat(typeClass, "-price-value") : null,
          "data-style-editor-text": isStyleEditable ? ".vdp .".concat(vehicleTypeClass, ".pricing-detail .").concat(typeClass, " .price-value") : null
        }, formattedPrice)), canadaDisclaimerMarkup];
      }));
    }
  }], [{
    key: "getLabel",
    // old VDP used to implement a flag called showCategory which was used to
    // determine if we should show conditional incentive type inline.  so it might
    // append 'military' or 'college' to the incentive title if it's set to true.
    // leaving this comment because it was removed as a check to show the descriptive label
    // but might be implemented again in the future and it's not documented anywhere else
    value: function getLabel(_ref4) {
      var price = _ref4.price,
          prefs = _ref4.prefs,
          labels = _ref4.labels,
          locale = _ref4.locale;
      var title = price.title,
          shortTitle = price.shortTitle,
          typeClass = price.typeClass,
          isFinalPrice = price.isFinalPrice,
          incentiveId = price.incentiveId;
      var label = price.label; // Conditional final price label is coming from BE as a label ID and not a translated label.
      // TODO remove this logic once CONDITIONAL_FINAL_PRICE label is being properly translated from BE.

      if (label === 'CONDITIONAL_FINAL_PRICE') {
        label = labels.get('CONDITIONAL_FINAL_PRICE');
      }

      var titlePref = prefs.incentiveTitleDisplay;
      var incentiveLabel = label;

      if (incentiveId) {
        if (title && title[locale] && titlePref === 'regular') {
          incentiveLabel = title[locale];
        }

        if (shortTitle && shortTitle[locale] && titlePref === 'descriptive') {
          incentiveLabel = shortTitle[locale];
        }

        if (titlePref === 'custom' && typeClass === 'discount' && !isFinalPrice) {
          incentiveLabel = labels.get(prefs.incentiveTitleCustom);
        }
      }

      return incentiveLabel;
    }
  }]);

  return PricingDetail;
}(_react.default.Component);

exports.default = PricingDetail;
PricingDetail.propTypes = {
  detail: _propTypes.default.arrayOf(_propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    typeClass: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired,
    isFinalPrice: _propTypes.default.bool,
    incentives: _propTypes.default.arrayOf(_propTypes.default.string),
    showCategory: _propTypes.default.bool
  })).isRequired,
  detailType: _propTypes.default.string,
  incentiveData: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string,
    label: _propTypes.default.string,
    offerDetails: _propTypes.default.string,
    shortTitle: _propTypes.default.string,
    effectiveDate: _propTypes.default.string,
    expirationDate: _propTypes.default.string,
    conditional: _propTypes.default.bool,
    error: _propTypes.default.string
  }).isRequired).isRequired,
  widgetInfo: _propTypes.default.shape({
    deviceType: _propTypes.default.string.isRequired,
    windowId: _propTypes.default.string.isRequired,
    widgetName: _propTypes.default.string.isRequired,
    vehicleType: _propTypes.default.string.isRequired
  }).isRequired,
  setModalStateData: _propTypes.default.func.isRequired,
  prefs: _propTypes.default.shape({
    priceDiscountColor: _propTypes.default.string,
    finalPriceSize: _propTypes.default.string,
    finalPriceColor: _propTypes.default.string
  }).isRequired,
  locale: _propTypes.default.string,
  dealerAddress: _propTypes.default.shape({
    address1: _propTypes.default.string,
    address2: _propTypes.default.string,
    address3: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    postalCode: _propTypes.default.string,
    country: _propTypes.default.string
  }),
  isFinalPriceFlagEnabled: _propTypes.default.bool.isRequired
};
PricingDetail.defaultProps = {
  detailType: '',
  locale: 'en_US',
  dealerAddress: {}
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _common = __webpack_require__(2);

var _ModalDock = __webpack_require__(24);

var _DisclaimerContent = _interopRequireDefault(__webpack_require__(13));

var _constants = __webpack_require__(6);

var _utility = __webpack_require__(3);

var _labels = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var PricingLoanLease =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingLoanLease, _React$Component);

  function PricingLoanLease() {
    var _this;

    _classCallCheck(this, PricingLoanLease);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PricingLoanLease).call(this));
    _this.state = {
      showDisclaimer: false,
      disclaimerTitle: _react.default.createElement("span", null),
      disclaimerContent: _react.default.createElement("span", null)
    };
    _this.renderLayout = _this.renderLayout.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.getModalDockOptions = _this.getModalDockOptions.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.toggleDisclaimer = _this.toggleDisclaimer.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.renderList = _this.renderList.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(PricingLoanLease, [{
    key: "getModalDockOptions",
    value: function getModalDockOptions(isMobile) {
      var _this$state = this.state,
          showDisclaimer = _this$state.showDisclaimer,
          disclaimerTitle = _this$state.disclaimerTitle,
          disclaimerContent = _this$state.disclaimerContent;
      return {
        display: isMobile ? _constants.DOCK : _constants.MODAL,
        showState: showDisclaimer,
        closeMethod: this.toggleDisclaimer,
        title: disclaimerTitle,
        body: disclaimerContent
      };
    }
  }, {
    key: "toggleDisclaimer",
    value: function toggleDisclaimer() {
      var disclaimerTitle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.default.createElement("span", null);
      var disclaimerContent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _react.default.createElement("span", null);
      this.setState({
        showDisclaimer: !this.state.showDisclaimer,
        disclaimerTitle: disclaimerTitle,
        disclaimerContent: disclaimerContent
      });
    }
  }, {
    key: "renderList",
    value: function renderList(item, index, listSize, labels) {
      var toggleDisclaimer = this.toggleDisclaimer;
      var _type = item._type,
          label = item.label,
          formatted = item.formatted,
          dealershipName = item.dealershipName;
      var isLeasePayment = _type === _constants.LEASE;
      var SECOND_ITEM = 2;
      var disclaimer = isLeasePayment ? _labels.FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE : _labels.FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE;
      var disclaimerPlaceholder = (0, _utility.getDisclaimerPlaceholderObj)(item);
      var disclaimerTitle = isLeasePayment ? _labels.EST_LEASE_DISCLAIMER_HEADING : _labels.EST_FINANCE_DISCLAIMER_HEADING;
      var listPosition = listSize === SECOND_ITEM ? 'two-item' : 'one-item';
      var border = index === SECOND_ITEM ? 'border-left' : null;
      var listClass = [listPosition, border];

      var DynamicDisclaimerContent = _react.default.createElement(_DisclaimerContent.default, {
        placeholderValuesObj: disclaimerPlaceholder,
        disclaimerLabel: disclaimer,
        dealershipName: dealershipName
      });

      var iconHtml = _react.default.createElement("i", {
        className: "ddc-icon ddc-icon-help-circle text-muted ddc-icon-size-small d-inline-block pl-1"
      });

      var labelHtml = _react.default.createElement("span", {
        className: "text-muted d-block text-nowrap"
      }, labels.get(label), _react.default.createElement("button", {
        className: "btn-link p-0",
        onClick: function onClick() {
          return toggleDisclaimer(labels.get(disclaimerTitle), DynamicDisclaimerContent);
        }
      }, iconHtml));

      var priceHtml = _react.default.createElement("strong", {
        className: "line-height-reset font-weight-bold ddc-font-size-large"
      }, formatted);

      var termHtml = _react.default.createElement("span", {
        className: "ddc-font-size-small text-muted"
      }, labels.get('SLASH_MO'));

      return _react.default.createElement("li", {
        className: "".concat(listClass.filter(Boolean).join(' ')),
        key: "".concat(label)
      }, labelHtml, _react.default.createElement("span", null, priceHtml, termHtml));
    }
  }, {
    key: "renderLayout",
    value: function renderLayout(_ref) {
      var labels = _ref.labels,
          prefs = _ref.prefs;
      var summary = this.props.summary;
      var renderList = this.renderList;
      var paymentBoxPadding = prefs.paymentBoxPadding,
          paymentBoxBackground = prefs.paymentBoxBackground;
      var layoutClasses = 'pricing-loan-lease list-unstyled d-flex mb-0';
      var paddingClasses = "px-".concat(paymentBoxPadding, " py-").concat(paymentBoxPadding);
      var componentClasses = [layoutClasses, paddingClasses, paymentBoxBackground];
      return _react.default.createElement("ul", {
        className: componentClasses.join(' ')
      }, summary.map(function (item, index) {
        return renderList(item, index + 1, summary.length, labels);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isMobile = _this$props.isMobile,
          isScrollingSidebar = _this$props.isScrollingSidebar;
      var getModalDockOptions = this.getModalDockOptions;
      var renderLoanLease = null;

      if (!isScrollingSidebar) {
        /* props for the ModalDock component */
        var options = getModalDockOptions(isMobile);
        renderLoanLease = _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_common.Common, {
          render: this.renderLayout
        }), _react.default.createElement(_ModalDock.ModalDock, options));
      }

      return renderLoanLease;
    }
  }]);

  return PricingLoanLease;
}(_react.default.Component);

PricingLoanLease.propTypes = {
  isMobile: _propTypes.default.bool.isRequired,
  summary: _propTypes.default.arrayOf(_propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    key: _propTypes.default.string,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired
  })).isRequired,
  isScrollingSidebar: _propTypes.default.bool.isRequired
};
var _default = PricingLoanLease;
exports.default = _default;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _common = __webpack_require__(2);

var _DisclaimersModal = _interopRequireDefault(__webpack_require__(14));

var _LabelAsHTML = _interopRequireDefault(__webpack_require__(9));

var _labels = __webpack_require__(4);

var _analytics = __webpack_require__(5);

var _CanadaDisclaimerContent = __webpack_require__(8);

__webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var PricingSummary =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummary, _React$Component);

  function PricingSummary(props) {
    var _this;

    _classCallCheck(this, PricingSummary);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PricingSummary).call(this, props));
    _this.state = {
      isModalVisible: false,
      paymentInfo: null
    };
    _this.closeModal = _this.closeModal.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(PricingSummary, [{
    key: "closeModal",
    value: function closeModal() {
      var _this$props$widgetInf = this.props.widgetInfo,
          widgetName = _this$props$widgetInf.widgetName,
          windowId = _this$props$widgetInf.windowId;
      (0, _analytics.disclaimerDetailsModalEvents)(widgetName, windowId, false);
      this.setState({
        isModalVisible: false
      });
    }
  }, {
    key: "handleHelpCircleIcon",
    value: function handleHelpCircleIcon(paymentInfo) {
      var _this$props$widgetInf2 = this.props.widgetInfo,
          widgetName = _this$props$widgetInf2.widgetName,
          windowId = _this$props$widgetInf2.windowId;
      (0, _analytics.disclaimerDetailsModalEvents)(widgetName, windowId, true);
      this.setState({
        isModalVisible: true,
        paymentInfo: paymentInfo
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var detailsLinkMarkup = _react.default.createElement("button", {
        onClick: this.props.viewPriceDetail,
        className: "text-link d-block ddc-font-size-xsmall"
      }, _react.default.createElement(_common.Common, {
        render: function render(_ref) {
          var labels = _ref.labels;
          return labels.get(_labels.DETAILS);
        }
      }));

      var _this$props$summary = this.props.summary,
          summary = _this$props$summary === void 0 ? [] : _this$props$summary;
      var showStickySidebarLoanLease = this.props.prefs.showStickySidebarLoanLease;
      var body;

      if (summary.length === 0) {
        return null;
      } else if (summary.length > 1 && showStickySidebarLoanLease === 'true') {
        body = _react.default.createElement("div", null, _react.default.createElement(_DisclaimersModal.default, {
          isModalVisible: this.state.isModalVisible,
          handleClose: this.closeModal,
          paymentInfo: this.state.paymentInfo
        }), _react.default.createElement("ul", {
          className: "pricing-summary list-unstyled d-flex align-items-end justify-items-between mb-4"
        }, summary.map(function (price) {
          var _type = price._type,
              isFinalPrice = price.isFinalPrice,
              label = price.label,
              formatted = price.formatted;
          var formattedValue = formatted;

          if (formattedValue === _labels.PLEASE_CALL) {
            formattedValue = _react.default.createElement(_common.Common, {
              render: function render(_ref2) {
                var labels = _ref2.labels;
                return labels.get(_labels.PLEASE_CALL);
              }
            });
          }

          var isLoanPayment = _type === 'LOAN';
          var isLeasePayment = _type === 'LEASE';
          var cursorPointerClass = isFinalPrice ? 'pointer' : '';
          var summaryClass = '';

          if (summary.length === 2 && isFinalPrice) {
            summaryClass = 'summary-price pr-4 mr-4 border-right half-width';
          } else if (summary.length === 2 && (isLoanPayment || isLeasePayment)) {
            summaryClass = 'mr-4 pr-4 half-width';
          } else if (isFinalPrice) {
            summaryClass = 'summary-price pr-4 mr-4 border-right third-width';
          } else if (isLoanPayment) {
            summaryClass = 'mr-3 third-width';
          } else if (isLeasePayment) {
            summaryClass = 'mr-4 pr-4 third-width';
          }

          var helpCircleIcon = '';

          if (isLeasePayment || isLoanPayment) {
            helpCircleIcon = _react.default.createElement("button", {
              onClick: function onClick() {
                return _this2.handleHelpCircleIcon(price);
              },
              className: "btn-link p-0"
            }, _react.default.createElement("i", {
              className: "ddc-icon ddc-icon-help-circle text-muted ddc-icon-size-small d-inline-block pl-1"
            }));
          }

          return (
            /* eslint jsx-a11y/click-events-have-key-events: 0, jsx-a11y/no-noninteractive-element-interactions: 0 */
            _react.default.createElement("li", {
              onClick: function onClick() {
                return isFinalPrice ? _this2.props.viewPriceDetail() : false;
              },
              className: "".concat(summaryClass, " ").concat(cursorPointerClass),
              key: _type
            }, _react.default.createElement("span", {
              className: "text-muted d-block text-nowrap"
            }, _react.default.createElement(_common.Common, {
              render: function render(_ref3) {
                var labels = _ref3.labels;
                return _react.default.createElement(_LabelAsHTML.default, {
                  label: labels.get(label)
                });
              }
            }), helpCircleIcon), _react.default.createElement("strong", {
              className: "line-height-reset ddc-font-size-large"
            }, formattedValue), _react.default.createElement("span", {
              className: "ddc-font-size-xsmall text-muted d-block line-height-reset"
            }, isFinalPrice ? detailsLinkMarkup : _react.default.createElement(_common.Common, {
              render: function render(_ref4) {
                var labels = _ref4.labels;
                return labels.get(_labels.PER_MONTH);
              }
            })))
          );
        })));
      } else {
        // single item (final price) will get detailed pricing markup
        // summary[0] will always be final price - ref: VCDApricing.js
        var _summary$ = summary[0],
            label = _summary$.label,
            formatted = _summary$.formatted;
        var dealerAddress = this.props.dealerAddress;
        var formattedValue = formatted;

        if (formattedValue === _labels.PLEASE_CALL) {
          formattedValue = _react.default.createElement(_common.Common, {
            render: function render(_ref5) {
              var labels = _ref5.labels;
              return labels.get(_labels.PLEASE_CALL);
            }
          });
        }

        body = _react.default.createElement("dl", {
          onClick: this.props.viewPriceDetail,
          className: "pricing-detail final-price line-height-condensed pointer mb-4"
        }, _react.default.createElement("dt", null, _react.default.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: label
          }
        }), detailsLinkMarkup), _react.default.createElement("dd", {
          className: "font-weight-bold ddc-font-size-large"
        }, formattedValue), _react.default.createElement(_CanadaDisclaimerContent.CaDisclaimer, {
          dealerAddress: dealerAddress
        }));
      }

      return body;
    }
  }]);

  return PricingSummary;
}(_react.default.Component);

exports.default = PricingSummary;
PricingSummary.propTypes = {
  prefs: _propTypes.default.shape({
    showStickySidebarLoanLease: _propTypes.default.string
  }).isRequired,
  summary: _propTypes.default.arrayOf(_propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired
  })).isRequired,
  viewPriceDetail: _propTypes.default.func.isRequired,
  widgetInfo: _propTypes.default.shape({
    windowId: _propTypes.default.string.isRequired,
    widgetName: _propTypes.default.string.isRequired,
    deviceType: _propTypes.default.string.isRequired
  }).isRequired,
  dealerAddress: _propTypes.default.shape({
    address1: _propTypes.default.string,
    address2: _propTypes.default.string,
    address3: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    postalCode: _propTypes.default.string,
    country: _propTypes.default.string
  })
};
PricingSummary.defaultProps = {
  dealerAddress: {}
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _PricingSummary = _interopRequireDefault(__webpack_require__(28));

var _PricingSummaryUpdated = _interopRequireDefault(__webpack_require__(15));

var _PricingSummaryPortal = _interopRequireDefault(__webpack_require__(35));

var _PricingSummaryFooterPortal = _interopRequireDefault(__webpack_require__(32));

var _analytics = __webpack_require__(5);

var _constants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var isBrowser = (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object';

var PricingSummaryContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummaryContainer, _React$Component);

  function PricingSummaryContainer(props) {
    var _this;

    _classCallCheck(this, PricingSummaryContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PricingSummaryContainer).call(this, props));
    _this.viewPriceDetail = _this.viewPriceDetail.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.scrollToAnchor = _this.scrollToAnchor.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(PricingSummaryContainer, [{
    key: "viewPriceDetail",
    value: function viewPriceDetail() {
      var _this$props$widgetInf = this.props.widgetInfo,
          widgetName = _this$props$widgetInf.widgetName,
          windowId = _this$props$widgetInf.windowId;
      (0, _analytics.priceDetailsScrollEvent)(widgetName, windowId);
      this.scrollToAnchor();
    }
  }, {
    key: "scrollToAnchor",
    value: function scrollToAnchor() {
      var deviceType = this.props.widgetInfo.deviceType;
      var isMobile = deviceType.toUpperCase() === 'MOBILE';
      var headerSelector = document && document.querySelector('[data-widget-id="template-navigation1"]');
      var scrollToSelector = '[data-widget-id="vehicle-title1"]';

      if (isMobile) {
        headerSelector = document && document.querySelector('[data-widget-id="template-navbar1"]');
        scrollToSelector = '[data-widget-id="detailed-pricing1"]';
      }

      var pageHeaderHeight = headerSelector && headerSelector.clientHeight || 0;

      if (DDC && DDC.scrollToAnchor) {
        /* eslint no-undef: 0 */
        DDC.scrollToAnchor($(scrollToSelector), {
          heightAdj: pageHeaderHeight + _constants.OFFSET_HEIGHT
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var deviceType = this.props.widgetInfo.deviceType;
      var _this$props = this.props,
          dealerAddress = _this$props.dealerAddress,
          prefs = _this$props.prefs,
          summary = _this$props.summary,
          widgetInfo = _this$props.widgetInfo,
          showMobilePricingSummary = _this$props.showMobilePricingSummary;
      var isMobile = deviceType.toUpperCase() === 'MOBILE';

      if (isMobile) {
        if (isBrowser) {
          return _react.default.createElement(_react.default.Fragment, null, showMobilePricingSummary && _react.default.createElement(_PricingSummaryPortal.default, {
            prefs: prefs,
            summary: summary,
            viewPriceDetail: this.viewPriceDetail,
            widgetInfo: widgetInfo,
            dealerAddress: dealerAddress,
            isMobile: isMobile
          }), _react.default.createElement(_PricingSummaryFooterPortal.default, {
            summary: summary,
            viewPriceDetail: this.viewPriceDetail,
            dealerAddress: dealerAddress
          }));
        }

        return null;
      }

      return showMobilePricingSummary ? _react.default.createElement(_PricingSummaryUpdated.default, {
        prefs: prefs,
        summary: summary,
        viewPriceDetail: this.viewPriceDetail,
        widgetInfo: widgetInfo,
        dealerAddress: dealerAddress,
        isMobile: isMobile
      }) : _react.default.createElement(_PricingSummary.default, {
        prefs: prefs,
        summary: summary,
        viewPriceDetail: this.viewPriceDetail,
        widgetInfo: widgetInfo,
        dealerAddress: dealerAddress,
        isMobile: isMobile
      });
    }
  }]);

  return PricingSummaryContainer;
}(_react.default.Component);

exports.default = PricingSummaryContainer;
PricingSummaryContainer.propTypes = {
  prefs: _propTypes.default.shape({
    showStickySidebarLoanLease: _propTypes.default.string
  }).isRequired,
  summary: _propTypes.default.arrayOf(_propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired
  })).isRequired,
  showMobilePricingSummary: _propTypes.default.bool,
  widgetInfo: _propTypes.default.shape({
    windowId: _propTypes.default.string.isRequired,
    widgetName: _propTypes.default.string.isRequired,
    deviceType: _propTypes.default.string.isRequired
  }).isRequired,
  dealerAddress: _propTypes.default.shape({
    address1: _propTypes.default.string,
    address2: _propTypes.default.string,
    address3: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    postalCode: _propTypes.default.string,
    country: _propTypes.default.string
  })
};
PricingSummaryContainer.defaultProps = {
  dealerAddress: {},
  showMobilePricingSummary: false
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _LabelAsHTML = _interopRequireDefault(__webpack_require__(9));

var _utility = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PricingSummaryFinalPrice = function PricingSummaryFinalPrice(_ref) {
  var price = _ref.price,
      buttonResetClasses = _ref.buttonResetClasses,
      viewPriceDetail = _ref.viewPriceDetail,
      finalLabelSize = _ref.finalLabelSize,
      finalPrice = _ref.finalPrice,
      finalPriceSize = _ref.finalPriceSize;

  if (price && price.isFinalPrice && finalPrice && viewPriceDetail) {
    return _react.default.createElement("button", {
      className: "".concat(buttonResetClasses, " w-100"),
      onClick: viewPriceDetail
    }, _react.default.createElement("span", {
      className: (0, _utility.setClassNames)('text-muted', 'd-block', finalLabelSize)
    }, _react.default.createElement(_LabelAsHTML.default, {
      label: price.label
    }), ' '), _react.default.createElement("strong", {
      className: (0, _utility.setClassNames)('line-height-reset', finalPriceSize)
    }, finalPrice));
  }

  return null;
};

PricingSummaryFinalPrice.propTypes = {
  price: _propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired
  }).isRequired,
  buttonResetClasses: _propTypes.default.string,
  viewPriceDetail: _propTypes.default.func.isRequired,
  finalLabelSize: _propTypes.default.string,
  finalPrice: _propTypes.default.string.isRequired,
  finalPriceSize: _propTypes.default.string
};
PricingSummaryFinalPrice.defaultProps = {
  buttonResetClasses: '',
  finalLabelSize: '',
  finalPriceSize: ''
};
var _default = PricingSummaryFinalPrice;
exports.default = _default;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _common = __webpack_require__(2);

var _labels = __webpack_require__(4);

var _utility = __webpack_require__(3);

__webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PricingSummaryFooter =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummaryFooter, _React$Component);

  function PricingSummaryFooter() {
    _classCallCheck(this, PricingSummaryFooter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PricingSummaryFooter).apply(this, arguments));
  }

  _createClass(PricingSummaryFooter, [{
    key: "render",
    value: function render() {
      var _this = this;

      var summary = this.props.summary;
      var displayPrice = summary.find(function (price) {
        return price.isFinalPrice;
      });

      if (!displayPrice) {
        return null;
      }

      return _react.default.createElement(_common.Common, {
        render: function render(_ref) {
          var labels = _ref.labels;
          var dealershipNamePriceText = (0, _utility.replacePlaceholders)(labels.get(_labels.DEALERSHIP_NAME_PRICE), {
            '<%=dealershipName%>': displayPrice.dealershipName
          });
          var formattedValue = displayPrice.formatted;

          if (formattedValue === _labels.PLEASE_CALL) {
            formattedValue = labels.get(_labels.PLEASE_CALL);
          }

          return (// using aria-hidden based on conversation with Rachael Arnold
            // and Jon Ferry. The data in the footer section is redundant
            // and comes after the detailed pricing data in the DOM
            _react.default.createElement("div", {
              onClick: _this.props.viewPriceDetail,
              role: "button",
              "aria-hidden": true
            }, _react.default.createElement("ul", {
              className: "pricing-summary list-unstyled line-height-condensed mb-2"
            }, _react.default.createElement("li", {
              className: "text-muted"
            }, _react.default.createElement("span", {
              className: "d-block text-truncate"
            }, dealershipNamePriceText)), _react.default.createElement("li", null, _react.default.createElement("strong", {
              className: "pr-3"
            }, formattedValue), _react.default.createElement("span", {
              className: "text-link"
            }, labels.get(_labels.DETAILS)))))
          );
        }
      });
    }
  }]);

  return PricingSummaryFooter;
}(_react.default.Component);

exports.default = PricingSummaryFooter;
PricingSummaryFooter.propTypes = {
  summary: _propTypes.default.arrayOf(_propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired
  })).isRequired,
  viewPriceDetail: _propTypes.default.func.isRequired
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(11));

var _PricingSummaryFooter = _interopRequireDefault(__webpack_require__(31));

var _utility = __webpack_require__(3);

var _CanadaDisclaimerContent = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PricingSummaryFooterPortal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummaryFooterPortal, _React$Component);

  function PricingSummaryFooterPortal(props) {
    var _this;

    _classCallCheck(this, PricingSummaryFooterPortal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PricingSummaryFooterPortal).call(this, props));
    _this.el = document.createElement('div');
    return _this;
  }

  _createClass(PricingSummaryFooterPortal, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.containerEl) {
        this.containerEl.removeChild(this.el);
      }
    }
  }, {
    key: "render",
    value: function render() {
      this.containerEl = (0, _utility.getDOMContainer)(document, '.ddc-detailed-pricing-footer');

      if (this.containerEl) {
        this.containerEl.appendChild(this.el);
      }

      var _this$props = this.props,
          dealerAddress = _this$props.dealerAddress,
          viewPriceDetail = _this$props.viewPriceDetail,
          summary = _this$props.summary;

      var summaryComp = _react.default.createElement("div", null, _react.default.createElement(_PricingSummaryFooter.default, {
        summary: summary,
        viewPriceDetail: viewPriceDetail
      }), _react.default.createElement(_CanadaDisclaimerContent.CaDisclaimer, {
        dealerAddress: dealerAddress,
        isFooter: true
      })); // if there is a pricing footer, render in portal


      if (this.containerEl) {
        return _reactDom.default.createPortal(summaryComp, this.el);
      }

      return summaryComp;
    }
  }]);

  return PricingSummaryFooterPortal;
}(_react.default.Component);

exports.default = PricingSummaryFooterPortal;
PricingSummaryFooterPortal.propTypes = {
  summary: _propTypes.default.arrayOf(_propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired
  })).isRequired,
  dealerAddress: _propTypes.default.shape({
    address1: _propTypes.default.string,
    address2: _propTypes.default.string,
    address3: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    postalCode: _propTypes.default.string,
    country: _propTypes.default.string
  }),
  viewPriceDetail: _propTypes.default.func.isRequired
};
PricingSummaryFooterPortal.defaultProps = {
  dealerAddress: {}
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _common = __webpack_require__(2);

var _utility = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PricingSummaryLink = function PricingSummaryLink(_ref) {
  var label = _ref.label,
      labelFontSize = _ref.labelFontSize,
      isCalculatePayment = _ref.isCalculatePayment,
      viewPriceDetail = _ref.viewPriceDetail;
  var calcPaymentClasses = isCalculatePayment ? ['calculate-payment-integrated', 'calculate-payment-scroll-up'] : [];

  if (label) {
    return _react.default.createElement("button", {
      onClick: !isCalculatePayment ? viewPriceDetail : null,
      className: _utility.setClassNames.apply(void 0, ['text-link', 'text-left', 'd-block', 'line-height-reset', labelFontSize].concat(calcPaymentClasses))
    }, _react.default.createElement(_common.Common, {
      render: function render(_ref2) {
        var labels = _ref2.labels;
        return labels.get(label);
      }
    }));
  }

  return null;
};

PricingSummaryLink.propTypes = {
  label: _propTypes.default.string.isRequired,
  labelFontSize: _propTypes.default.string,
  isCalculatePayment: _propTypes.default.bool,
  viewPriceDetail: _propTypes.default.func
};
PricingSummaryLink.defaultProps = {
  labelFontSize: '',
  isCalculatePayment: false,
  viewPriceDetail: function viewPriceDetail() {}
};
var _default = PricingSummaryLink;
exports.default = _default;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _common = __webpack_require__(2);

var _LabelAsHTML = _interopRequireDefault(__webpack_require__(9));

var _labels = __webpack_require__(4);

var _utility = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PricingSummaryPayments = function PricingSummaryPayments(_ref) {
  var price = _ref.price,
      paymentLabelSize = _ref.paymentLabelSize,
      paymentPrice = _ref.paymentPrice,
      paymentPriceSize = _ref.paymentPriceSize,
      handleHelpCircleIcon = _ref.handleHelpCircleIcon;

  if (price && !price.isFinalPrice && paymentPrice) {
    return _react.default.createElement("span", {
      className: "flex-grow-1"
    }, _react.default.createElement("span", {
      className: (0, _utility.setClassNames)('text-muted', 'text-nowrap', 'd-block', paymentLabelSize)
    }, _react.default.createElement(_common.Common, {
      render: function render(_ref2) {
        var labels = _ref2.labels;
        return _react.default.createElement(_LabelAsHTML.default, {
          label: labels.get(price.label)
        });
      }
    }), _react.default.createElement("button", {
      className: "text-link line-height-reset help-icon",
      onClick: handleHelpCircleIcon
    }, _react.default.createElement("i", {
      className: "ddc-icon ddc-icon-help-circle text-muted d-inline-block pl-1"
    }))), _react.default.createElement("strong", {
      className: (0, _utility.setClassNames)('line-height-reset', paymentPriceSize)
    }, paymentPrice), _react.default.createElement("span", {
      className: "ddc-font-size-small text-muted d-inline line-height-reset"
    }, _react.default.createElement(_common.Common, {
      render: function render(_ref3) {
        var labels = _ref3.labels;
        return labels.get(_labels.SLASH_MO);
      }
    })));
  }

  return null;
};

PricingSummaryPayments.propTypes = {
  price: _propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired
  }).isRequired,
  paymentLabelSize: _propTypes.default.string,
  paymentPrice: _propTypes.default.string.isRequired,
  paymentPriceSize: _propTypes.default.string,
  handleHelpCircleIcon: _propTypes.default.func.isRequired
};
PricingSummaryPayments.defaultProps = {
  paymentLabelSize: '',
  paymentPriceSize: ''
};
var _default = PricingSummaryPayments;
exports.default = _default;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(11));

var _PricingSummaryUpdated = _interopRequireDefault(__webpack_require__(15));

var _utility = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PricingSummaryPortal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummaryPortal, _React$Component);

  function PricingSummaryPortal() {
    _classCallCheck(this, PricingSummaryPortal);

    return _possibleConstructorReturn(this, _getPrototypeOf(PricingSummaryPortal).apply(this, arguments));
  }

  _createClass(PricingSummaryPortal, [{
    key: "render",
    value: function render() {
      this.containerEl = (0, _utility.getDOMContainer)(document, '.ddc-vehicle-pricing-summary');
      var _this$props = this.props,
          dealerAddress = _this$props.dealerAddress,
          viewPriceDetail = _this$props.viewPriceDetail,
          summary = _this$props.summary,
          prefs = _this$props.prefs,
          widgetInfo = _this$props.widgetInfo,
          isMobile = _this$props.isMobile;

      var summaryComp = _react.default.createElement(_PricingSummaryUpdated.default, {
        prefs: prefs,
        summary: summary,
        viewPriceDetail: viewPriceDetail,
        widgetInfo: widgetInfo,
        dealerAddress: dealerAddress,
        isMobile: isMobile
      }); // if there is a pricing summary, render in portal


      if (this.containerEl) {
        return _reactDom.default.createPortal(summaryComp, this.containerEl);
      }

      return null;
    }
  }]);

  return PricingSummaryPortal;
}(_react.default.Component);

exports.default = PricingSummaryPortal;
PricingSummaryPortal.propTypes = {
  prefs: _propTypes.default.shape({
    showStickySidebarLoanLease: _propTypes.default.string
  }).isRequired,
  summary: _propTypes.default.arrayOf(_propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired
  })).isRequired,
  widgetInfo: _propTypes.default.shape({
    windowId: _propTypes.default.string.isRequired,
    widgetName: _propTypes.default.string.isRequired,
    deviceType: _propTypes.default.string.isRequired
  }).isRequired,
  viewPriceDetail: _propTypes.default.func.isRequired,
  dealerAddress: _propTypes.default.shape({
    address1: _propTypes.default.string,
    address2: _propTypes.default.string,
    address3: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    postalCode: _propTypes.default.string,
    country: _propTypes.default.string
  }),
  isMobile: _propTypes.default.bool.isRequired
};
PricingSummaryPortal.defaultProps = {
  dealerAddress: {}
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _lodash = _interopRequireDefault(__webpack_require__(17));

var _melankeWatchjs = _interopRequireDefault(__webpack_require__(62));

var _InstantEPriceButton = _interopRequireDefault(__webpack_require__(23));

var _utility = __webpack_require__(3);

var _analytics = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var InstantEPriceContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InstantEPriceContainer, _React$Component);

  function InstantEPriceContainer(props) {
    var _this;

    _classCallCheck(this, InstantEPriceContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InstantEPriceContainer).call(this, props));
    _this.state = {
      isModalVisible: false,
      loadingUserProfile: true,
      userLoggedIn: false
    };
    _this.modalOpen = _this.modalOpen.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.modalClose = _this.modalClose.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.internalShowEprice = _this.internalShowEprice.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.checkUserProfile = _this.checkUserProfile.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(InstantEPriceContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _window = window,
          pubsub = _window.pubsub;

      if (pubsub) {
        pubsub.subscribe('instant-eprice.complete', function () {
          _this2.internalShowEprice();
        });
      } // if userProfile is loaded (!== undefined)


      if (window.DDC && window.DDC.userProfile) {
        this.checkUserProfile();
      } // if userProfile is not loaded yet (=== undefined) OR userProfile change its value


      _melankeWatchjs.default.watch(window.DDC, 'userProfile', this.checkUserProfile); // required to make instant eprice work on mobile


      var ddcSlideIn = (0, _lodash.default)(window, 'DDC.mobile.slidein', undefined);

      if (this.props.isMobile && ddcSlideIn) {
        ddcSlideIn.init();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _melankeWatchjs.default.noMore = true;
    }
  }, {
    key: "checkUserProfile",
    value: function checkUserProfile() {
      var _this3 = this;

      var userProfile = (0, _lodash.default)(window, 'DDC.userProfile', undefined);

      if (userProfile) {
        this.setState({
          loadingUserProfile: false
        });

        if (this.props.instantEpriceShowAllAfterLeadSubmit === 'true' && userProfile && Object.entries(userProfile).length !== 0 && !this.state.isModalVisible) {
          this.internalShowEprice();
        } else {
          var ePriceVehicles = userProfile.ePriceVehicles;

          if (ePriceVehicles) {
            var found = ePriceVehicles.find(function (vehicle) {
              return vehicle.itemUUID === _this3.props.widgetInfo.vehicleId;
            }); // when user has the vehicle in their profile

            if (found && !this.state.isModalVisible) {
              this.internalShowEprice();
            } // when user does not have the vehicle in their profile but logs into MyCars
            else if (userProfile.profileId) {
                this.setState({
                  userLoggedIn: true
                });
              }
          }
        }
      }
    }
  }, {
    key: "internalShowEprice",
    value: function internalShowEprice(e) {
      var _window2 = window,
          pubsub = _window2.pubsub;
      var ePriceDetail = this.props.ePriceDetail; // vcda does not always return an eprice detail

      if (ePriceDetail && pubsub) {
        var _extractEPriceData = (0, _utility.extractEPriceData)(ePriceDetail),
            ePriceDifference = _extractEPriceData.ePriceDifference,
            ePriceValue = _extractEPriceData.ePriceValue;

        pubsub.publish('instant-eprice.show', {
          ePriceDifference: ePriceDifference,
          yourEPrice: ePriceValue
        });
      }

      this.props.showEPrice();
      _melankeWatchjs.default.noMore = true;

      if (e) {
        (0, _analytics.ePriceButtonTrackEvent)(this.props.buttonLabel, this.props.widgetInfo.widgetName, this.props.widgetInfo.windowId, false);
      }
    }
  }, {
    key: "modalClose",
    value: function modalClose() {
      this.setState({
        isModalVisible: false
      });
      var _window3 = window,
          pubsub = _window3.pubsub;

      if (pubsub) {
        pubsub.subscribe('instant-eprice.open', this.modalOpen);
      }
    }
  }, {
    key: "modalOpen",
    value: function modalOpen() {
      this.setState({
        isModalVisible: true
      });
      var _window4 = window,
          pubsub = _window4.pubsub;

      if (pubsub) {
        pubsub.subscribe('instant-eprice.cancel', this.modalClose);
      }

      (0, _analytics.ePriceButtonTrackEvent)(this.props.buttonLabel, this.props.widgetInfo.widgetName, this.props.widgetInfo.windowId, true);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isDisplayingEprice = _this$props.isDisplayingEprice,
          buttonLabel = _this$props.buttonLabel,
          pendingLabel = _this$props.pendingLabel,
          _this$props$widgetInf = _this$props.widgetInfo,
          vehicleId = _this$props$widgetInf.vehicleId,
          vehicleCategory = _this$props$widgetInf.vehicleCategory,
          pageAlias = _this$props$widgetInf.pageAlias,
          buttonStyle = _this$props.buttonStyle,
          buttonMobileClass = _this$props.buttonMobileClass,
          disabled = _this$props.disabled,
          preventMultipleEpriceLeads = _this$props.preventMultipleEpriceLeads;
      var clickAction = this.modalOpen;

      if (isDisplayingEprice) {
        return null;
      }

      if (this.state.userLoggedIn) {
        clickAction = this.internalShowEprice;
      }

      return _react.default.createElement(_InstantEPriceButton.default, {
        key: "button",
        userLoggedIn: this.state.userLoggedIn,
        loadingUserProfile: this.state.loadingUserProfile,
        isModalVisible: this.state.isModalVisible,
        buttonLabel: buttonLabel,
        pendingLabel: pendingLabel,
        handleClick: clickAction,
        vehicleId: vehicleId,
        vehicleCategory: vehicleCategory,
        pageAlias: pageAlias,
        buttonStyle: buttonStyle,
        buttonMobileClass: buttonMobileClass,
        disabled: disabled,
        preventMultipleEpriceLeads: preventMultipleEpriceLeads
      });
    }
  }]);

  return InstantEPriceContainer;
}(_react.default.Component);

InstantEPriceContainer.propTypes = {
  showEPrice: _propTypes.default.func.isRequired,
  isDisplayingEprice: _propTypes.default.bool.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  ePriceDetail: _propTypes.default.arrayOf(_propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    key: _propTypes.default.string,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired,
    isFinalPrice: _propTypes.default.bool,
    incentives: _propTypes.default.arrayOf(_propTypes.default.string)
  })),
  buttonLabel: _propTypes.default.string.isRequired,
  pendingLabel: _propTypes.default.string.isRequired,
  widgetInfo: _propTypes.default.shape({
    vehicleId: _propTypes.default.string.isRequired,
    vehicleCategory: _propTypes.default.string.isRequired,
    pageAlias: _propTypes.default.string.isRequired,
    windowId: _propTypes.default.string.isRequired,
    widgetName: _propTypes.default.string.isRequired
  }).isRequired,
  buttonStyle: _propTypes.default.string,
  buttonMobileClass: _propTypes.default.string.isRequired,
  instantEpriceShowAllAfterLeadSubmit: _propTypes.default.string,
  isMobile: _propTypes.default.bool.isRequired,
  preventMultipleEpriceLeads: _propTypes.default.bool.isRequired
};
InstantEPriceContainer.defaultProps = {
  ePriceDetail: [],
  buttonStyle: 'primary',
  instantEpriceShowAllAfterLeadSubmit: 'false'
};
var _default = InstantEPriceContainer;
exports.default = _default;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WidgetContainer = void 0;

var _reactRedux = __webpack_require__(12);

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _common = __webpack_require__(2);

var _utility = __webpack_require__(3);

var _PricingDetail = _interopRequireDefault(__webpack_require__(26));

var _PricingLoanLease = _interopRequireDefault(__webpack_require__(27));

var _PricingSummaryContainer = _interopRequireDefault(__webpack_require__(29));

var _IncentiveModal = _interopRequireDefault(__webpack_require__(22));

var _IncentiveDock = _interopRequireDefault(__webpack_require__(21));

var _InstantEPrice = _interopRequireDefault(__webpack_require__(36));

var _PaymentCalculatorButton = __webpack_require__(25);

var _labels = __webpack_require__(4);

__webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var WidgetContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WidgetContainer, _React$Component);

  function WidgetContainer(props) {
    var _this;

    _classCallCheck(this, WidgetContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WidgetContainer).call(this, props));
    _this.state = {
      incentive: {},
      isModalVisible: false,
      isDisplayingEprice: false,
      isScrollingSidebar: false
    };
    _this.setModalStateData = _this.setModalStateData.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.showEPrice = _this.showEPrice.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.trackScrollingSidebar = _this.trackScrollingSidebar.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(WidgetContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.deviceType === 'DESKTOP') {
        window.addEventListener('scroll', this.trackScrollingSidebar);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.deviceType === 'DESKTOP') {
        window.removeEventListener('scroll', this.trackScrollingSidebar);
      }
    }
  }, {
    key: "setModalStateData",
    value: function setModalStateData(incentive, isModalVisible) {
      this.setState({
        incentive: incentive,
        isModalVisible: isModalVisible
      });
    }
  }, {
    key: "showEPrice",
    value: function showEPrice() {
      this.setState({
        isDisplayingEprice: true
      });
    }
  }, {
    key: "trackScrollingSidebar",
    value: function trackScrollingSidebar() {
      // Tracks whether the sidebar is scrolling or not based on the height set
      this.setState({
        isScrollingSidebar: document.querySelector('.vdp-sidebar').style.top.length > 0
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          pricing = _this$props.pricing,
          widgetInfo = _this$props.widgetInfo,
          incentiveData = _this$props.incentiveData,
          windowId = _this$props.windowId,
          widgetName = _this$props.widgetName,
          deviceType = _this$props.deviceType,
          locale = _this$props.locale,
          dealerAddress = _this$props.dealerAddress;
      var accountId = widgetInfo.accountId,
          vehicleAccountId = widgetInfo.vehicleAccountId,
          vehicleType = widgetInfo.vehicleType;
      var isMobile = deviceType === 'MOBILE';
      var rootComponent;

      if (pricing) {
        var disableInstantEpriceButton = false; // This flag is never set to 'false'. Either it's there and set to 'true'
        // or it's simply not delivered from VCDA.

        if (pricing.disableEpriceOnVDP) {
          disableInstantEpriceButton = true;
        } // TODO: remove after VCDA release
        else if (pricing.summary) {
            var eprice = pricing.summary.filter(function (x) {
              return x.priceType === 'EPRICE';
            })[0];
            var dprice = pricing.summary.filter(function (x) {
              return x.priceType === 'DPRICE';
            })[0];

            if (eprice && dprice) {
              disableInstantEpriceButton = !(eprice.value < dprice.value);
            }
          }

        var mobileDialog = _react.default.createElement(_IncentiveDock.default, {
          incentive: this.state.incentive,
          isModalVisible: this.state.isModalVisible,
          setModalStateData: this.setModalStateData,
          widgetInfo: {
            windowId: windowId,
            widgetName: widgetName,
            deviceType: deviceType
          }
        });

        var regularDialog = _react.default.createElement(_IncentiveModal.default, {
          incentive: this.state.incentive,
          isModalVisible: this.state.isModalVisible,
          setModalStateData: this.setModalStateData,
          widgetInfo: {
            windowId: windowId,
            widgetName: widgetName,
            deviceType: deviceType
          }
        });

        var detailType = pricing.detail.ePrice && this.state.isDisplayingEprice ? 'ePrice' : 'dPrice';
        var summary = (0, _utility.filterSummary)(pricing.summary, detailType);
        var loanLeaseSummary = (0, _utility.filterLoanLease)(pricing.summary);
        rootComponent = _react.default.createElement(_common.Common, {
          render: function render(_ref) {
            var flags = _ref.flags,
                prefs = _ref.prefs,
                labels = _ref.labels;
            var ePricePendingLabel = labels.get(_labels.EPRICE_PENDING);
            var buttonMobileClass = prefs.showLoanLeasePricing === 'true' ? 'mb-4' : 'mb-0';
            var instantEpricePreventMultipleEpriceLeads = prefs.instantEpricePreventMultipleEpriceLeads === 'true';
            var instantEPriceContainer = pricing.detail.ePrice && ( // compare request account and vehicle account equality to determine
            // whether a vehicle is off-site
            prefs.showInstantEpriceForSharedInventory !== 'false' || accountId === vehicleAccountId) ? _react.default.createElement(_InstantEPrice.default, {
              showEPrice: _this2.showEPrice,
              isDisplayingEprice: _this2.state.isDisplayingEprice,
              instantEpriceShowAllAfterLeadSubmit: prefs.instantEpriceShowAllAfterLeadSubmit,
              ePriceDetail: pricing.detail.ePrice,
              buttonLabel: pricing.ePriceButtonLabel,
              pendingLabel: ePricePendingLabel,
              widgetInfo: _objectSpread({}, widgetInfo, {
                windowId: windowId,
                widgetName: widgetName
              }),
              buttonStyle: prefs.buttonStyleEPrice,
              buttonMobileClass: buttonMobileClass,
              preventMultipleEpriceLeads: instantEpricePreventMultipleEpriceLeads,
              isMobile: isMobile,
              disabled: disableInstantEpriceButton
            }) : null;
            var isFinalPriceFlagEnabled = flags['ws-detailed-pricing.use-final-price-for-instant-eprice'] === true; // Toggles the display of the pricing summary on mobile

            var showMobilePricingSummary = flags['ws-detailed-toggle-summary-pricing'] === true;
            var DDCExists = typeof window !== 'undefined' && typeof window.DDC !== 'undefined';
            var drEnable = false;
            /* eslint no-undef: 0 */

            if (DDCExists && DDC.getSiteProperty) {
              drEnable = DDC.getSiteProperty(prefs.paymentCalculatorButtonDisplayCondition);
            }

            return _react.default.createElement("div", null, _react.default.createElement(_PricingDetail.default, {
              detail: pricing.detail[detailType],
              detailType: detailType,
              widgetInfo: {
                windowId: windowId,
                widgetName: widgetName,
                deviceType: deviceType,
                vehicleType: vehicleType
              },
              prefs: prefs,
              setModalStateData: _this2.setModalStateData,
              incentiveData: incentiveData,
              locale: locale,
              dealerAddress: dealerAddress,
              isFinalPriceFlagEnabled: isFinalPriceFlagEnabled
            }), _react.default.createElement(_PricingSummaryContainer.default, {
              summary: summary,
              prefs: prefs,
              dealerAddress: dealerAddress,
              showMobilePricingSummary: showMobilePricingSummary,
              widgetInfo: {
                windowId: windowId,
                widgetName: widgetName,
                deviceType: deviceType
              }
            }), instantEPriceContainer, loanLeaseSummary.length > 0 && prefs.showLoanLeasePricing === 'true' && _react.default.createElement(_PricingLoanLease.default, {
              summary: loanLeaseSummary,
              isMobile: isMobile,
              isScrollingSidebar: _this2.state.isScrollingSidebar
            }), drEnable && _react.default.createElement(_PaymentCalculatorButton.PaymentCalculatorButton, {
              isLoanLeaseAvailable: loanLeaseSummary.length > 0 && prefs.showLoanLeasePricing === 'true',
              isScrollingSidebar: _this2.state.isScrollingSidebar,
              isMobile: isMobile,
              prefs: prefs,
              labels: labels
            }), isMobile ? mobileDialog : regularDialog);
          }
        }) // Common
        ;
      }

      return rootComponent;
    }
  }]);

  return WidgetContainer;
}(_react.default.Component);

exports.WidgetContainer = WidgetContainer;
WidgetContainer.propTypes = {
  pricing: _propTypes.default.shape({
    detail: _propTypes.default.shape({
      dPrice: _propTypes.default.arrayOf(_propTypes.default.shape({
        _type: _propTypes.default.string.isRequired,
        formatted: _propTypes.default.string.isRequired,
        label: _propTypes.default.string.isRequired,
        value: _propTypes.default.number.isRequired,
        incentives: _propTypes.default.arrayOf(_propTypes.default.string)
      })).isRequired,
      ePrice: _propTypes.default.arrayOf(_propTypes.default.shape({
        _type: _propTypes.default.string.isRequired,
        formatted: _propTypes.default.string.isRequired,
        label: _propTypes.default.string.isRequired,
        value: _propTypes.default.number.isRequired,
        incentives: _propTypes.default.arrayOf(_propTypes.default.string)
      }))
    }),
    summary: _propTypes.default.arrayOf(_propTypes.default.shape({
      _type: _propTypes.default.string.isRequired,
      formatted: _propTypes.default.string.isRequired,
      label: _propTypes.default.string.isRequired,
      value: _propTypes.default.number.isRequired
    })),
    ePriceButtonLabel: _propTypes.default.string.isRequired
  }),
  incentiveData: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string,
    label: _propTypes.default.string,
    offerDetails: _propTypes.default.string,
    shortTitle: _propTypes.default.string,
    effectiveDate: _propTypes.default.string,
    expirationDate: _propTypes.default.string,
    conditional: _propTypes.default.bool,
    error: _propTypes.default.string
  }).isRequired).isRequired,
  widgetInfo: _propTypes.default.shape({
    vehicleId: _propTypes.default.string.isRequired,
    vehicleCategory: _propTypes.default.string.isRequired,
    vehicleType: _propTypes.default.string.isRequired,
    pageAlias: _propTypes.default.string.isRequired
  }).isRequired,
  windowId: _propTypes.default.string.isRequired,
  widgetName: _propTypes.default.string.isRequired,
  deviceType: _propTypes.default.string.isRequired,
  locale: _propTypes.default.string,
  dealerAddress: _propTypes.default.shape({
    address1: _propTypes.default.string,
    address2: _propTypes.default.string,
    address3: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    postalCode: _propTypes.default.string,
    country: _propTypes.default.string
  })
};
WidgetContainer.defaultProps = {
  pricing: [],
  locale: 'en_US',
  dealerAddress: {}
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    pricing: state.pricing,
    widgetInfo: state.widgetInfo,
    incentiveData: state.incentive.incentiveData,
    windowId: state.requestData.windowId,
    widgetName: state.requestData.widgetName,
    deviceType: state.requestData.deviceType,
    locale: state.requestData.locale,
    dealerAddress: state.dealerAddress
  };
};

var mapDispatchToProps = function mapDispatchToProps(_dispatch) {
  return {};
};

var Widget = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WidgetContainer);
var _default = Widget;
exports.default = _default;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [];
exports.default = _default;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = dealerAddress;

var _types = __webpack_require__(7);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  address1: '',
  address2: '',
  address3: '',
  city: '',
  state: '',
  postalCode: '',
  country: ''
};

function dealerAddress() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    switch (action.type) {
      case _types.SET_DEALER_ADDRESS:
        return _objectSpread({}, state, action.payload);

      default:
    }
  }

  return state;
}

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = incentive;

var _types = __webpack_require__(7);

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  incentiveData: [{
    key: '',
    label: '',
    title: '',
    shortTitle: '',
    offerDetails: '',
    disclaimer: '',
    effectiveDate: '',
    expirationDate: ''
  }]
};

function incentive() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error) {
    switch (action.type) {
      case _types.SET_INCENTIVE:
        return _objectSpread({}, state, {
          incentiveData: _toConsumableArray(state.incentiveData).concat(_toConsumableArray(action.payload))
        });

      default:
    }
  }

  return state;
}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dealerAddress = _interopRequireDefault(__webpack_require__(39));

var _pricing = _interopRequireDefault(__webpack_require__(43));

var _incentive = _interopRequireDefault(__webpack_require__(40));

var _modal = _interopRequireDefault(__webpack_require__(42));

var _widgetInfo = _interopRequireDefault(__webpack_require__(44));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var root = {
  dealerAddress: _dealerAddress.default,
  pricing: _pricing.default,
  incentive: _incentive.default,
  modal: _modal.default,
  widgetInfo: _widgetInfo.default
};
var _default = root;
exports.default = _default;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = modal;

var _types = __webpack_require__(7);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialModalState = {
  show: false,
  incentiveKey: ' '
};

function modal() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialModalState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    switch (action.type) {
      case _types.SET_MODAL:
        return _objectSpread({}, state, {
          show: action.payload.show,
          incentiveKey: action.payload.incentiveKey
        });

      default:
        return state;
    }
  }

  return state;
}

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = pricing;

var _types = __webpack_require__(7);

function pricing() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    switch (action.type) {
      case _types.SET_PRICING:
        return action.payload;

      default:
    }
  }

  return state;
}

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = widgetInfo;

var _types = __webpack_require__(7);

function widgetInfo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    if (action.type && action.type === _types.SET_WIDGET_INFO) {
      var _action$payload = action.payload,
          accountId = _action$payload.accountId,
          pageAlias = _action$payload.pageAlias,
          vehicleAccountId = _action$payload.vehicleAccountId,
          vehicleCategory = _action$payload.vehicleCategory,
          vehicleType = _action$payload.vehicleType,
          vehicleId = _action$payload.vehicleId;
      return {
        accountId: accountId,
        pageAlias: pageAlias,
        vehicleAccountId: vehicleAccountId,
        vehicleCategory: vehicleCategory,
        vehicleType: vehicleType,
        vehicleId: vehicleId
      };
    }
  }

  return state;
}

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Collapse = function Collapse(props) {
  var id = props.id,
      children = props.children,
      toggleCollapse = props.toggleCollapse;

  if (toggleCollapse) {
    return _react.default.createElement("div", {
      id: "".concat(id, "-collapse"),
      className: "collapse collapse-content"
    }, children);
  }

  return children;
};

Collapse.propTypes = {
  id: _propTypes.default.string.isRequired,
  children: _propTypes.default.element.isRequired,
  toggleCollapse: _propTypes.default.bool
};
Collapse.defaultProps = {
  toggleCollapse: false
};
var _default = Collapse;
exports.default = _default;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _common = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

// eslint-disable-line import/no-unresolved
var WidgetHeading =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WidgetHeading, _React$Component);

  function WidgetHeading(props) {
    var _this;

    _classCallCheck(this, WidgetHeading);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WidgetHeading).call(this, props));
    _this.renderDelegate = _this.renderDelegate.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(WidgetHeading, [{
    key: "renderDelegate",
    value: function renderDelegate(_ref) {
      var labels = _ref.labels;
      var _this$props = this.props,
          HeadingTag = _this$props.HeadingTag,
          headingText = _this$props.headingText,
          widgetId = _this$props.widgetId,
          toggleCollapse = _this$props.toggleCollapse,
          showIcon = _this$props.showIcon,
          headingClasses = _this$props.headingClasses,
          iconClasses = _this$props.iconClasses;

      var allIconClasses = _toConsumableArray(iconClasses);

      var collapseAttributes = {};

      if (toggleCollapse) {
        var iconExpand = 'ddc-icon-expand';
        allIconClasses.push(iconExpand);
        allIconClasses.push('icon-style-collapse');
        collapseAttributes = {
          role: 'button',
          'data-toggle': 'collapse',
          'data-target': "#".concat(widgetId, "-collapse"),
          'data-expand-icon-class': "".concat(iconExpand),
          'data-collapse-icon-class': 'ddc-icon-collapse',
          'aria-expanded': 'false',
          'aria-controls': "".concat(widgetId, "-collapse")
        };
      }

      return _react.default.createElement(HeadingTag, _extends({
        className: headingClasses.join(' ')
      }, collapseAttributes), showIcon && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("i", {
        className: allIconClasses.join(' ')
      }), ' '), labels.getHTML(headingText));
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.headingText || this.props.headingText.toUpperCase() === 'FALSE') {
        return null;
      } else {
        return _react.default.createElement(_common.Common, {
          render: this.renderDelegate
        });
      }
    }
  }]);

  return WidgetHeading;
}(_react.default.Component);

WidgetHeading.propTypes = {
  HeadingTag: _propTypes.default.string,
  headingText: _propTypes.default.string,
  widgetId: _propTypes.default.string.isRequired,
  toggleCollapse: _propTypes.default.bool.isRequired,
  showIcon: _propTypes.default.bool.isRequired,
  headingClasses: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  iconClasses: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
};
WidgetHeading.defaultProps = {
  HeadingTag: 'h3',
  headingText: ''
};
var _default = WidgetHeading;
exports.default = _default;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flags;

function flags() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_FEATURE_FLAGS':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = labels;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function labels() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_ADD_LABELS':
        return _objectSpread({}, state, action.payload);
      // no default
    }
  }

  return state;
}

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefs;

function prefs() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_PREFS':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = requestData;

function requestData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_REQUEST_DATA':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sitemap;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function sitemap() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_ADD_SITEMAP':
        return _objectSpread({}, state, action.payload);
      // no default
    }
  }

  return state;
}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStore = createStore;

var _redux = __webpack_require__(73);

var _reduxThunk = _interopRequireDefault(__webpack_require__(74));

var _reducers = _interopRequireDefault(__webpack_require__(41));

var _requestData = _interopRequireDefault(__webpack_require__(50));

var _prefs = _interopRequireDefault(__webpack_require__(49));

var _labels = _interopRequireDefault(__webpack_require__(48));

var _sitemap = _interopRequireDefault(__webpack_require__(51));

var _flags = _interopRequireDefault(__webpack_require__(47));

var _middleware = _interopRequireDefault(__webpack_require__(38));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// eslint-disable-line import/no-unresolved
var providedReducers = {
  requestData: _requestData.default,
  prefs: _prefs.default,
  labels: _labels.default,
  sitemap: _sitemap.default,
  flags: _flags.default
};
var reducers = (0, _redux.combineReducers)(_objectSpread({}, _reducers.default, providedReducers));

var middleware = _toConsumableArray(_middleware.default).concat([_reduxThunk.default]);

var locationContains = function locationContains(search) {
  return window.location.toString().indexOf(search) !== -1;
};

var isBrowser = typeof window !== 'undefined';
var showReduxLoggerFromUrlParam = isBrowser && (locationContains('_mode=debug') || locationContains('wsScriptsUseReduxLogger=true'));

if (isBrowser && ("production" === 'development' || showReduxLoggerFromUrlParam)) {
  // Note: This must the be last middleware in the chain so that it logs actions
  // instead of thunks or Promises.
  // Use an actionTransformer to get the widget name into the output since
  // we have multiple stores running on one page. It may seem like using
  // titleFormatter makes more sense for this purpose, but doing so loses the
  // readability improvement coloring added in 2.10.0 of redux-logger. As of
  // 3.0.6, there is no way to get colors without using the default title formatter.
  // With the below action transformer and default title formatter, we get:
  // action ws-GENERIC-WIDGET-NAME - MIDDLEWARE_TEST @ 17:47:41.612 (in 0.30 ms)
  var actionTransformer = function actionTransformer(action) {
    return _objectSpread({}, action, {
      type: "ws-detailed-pricing - ".concat(action.type)
    });
  };

  var _require = __webpack_require__(71),
      createLogger = _require.createLogger;

  var logger = createLogger({
    actionTransformer: actionTransformer,
    duration: true
  });
  middleware.push(logger);
}

var enhancer = _redux.applyMiddleware.apply(void 0, _toConsumableArray(middleware));

function createStore(initialState) {
  var store = (0, _redux.createStore)(reducers, initialState, enhancer);

  if (false) {
    module.hot.accept('../reducers', function () {
      var defaultReducers = require('../reducers').default; // eslint-disable-line import/no-unresolved


      store.replaceReducer((0, _redux.combineReducers)(_objectSpread({}, defaultReducers, providedReducers)));
    });
  }

  return store;
}

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidgetComponents = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRedux = __webpack_require__(12);

var _WidgetHeading = _interopRequireDefault(__webpack_require__(46));

var _Collapse = _interopRequireDefault(__webpack_require__(45));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getIconClasses = function getIconClasses(prefs, showIcon, toggleCollapse) {
  var iconClasses = [];
  var widgetHeading = prefs.widgetHeading,
      headingIconClasses = prefs.headingIconClasses,
      headingIconSize = prefs.headingIconSize,
      headingIconStyle = prefs.headingIconStyle;

  if (widgetHeading && showIcon) {
    iconClasses.push('ddc-icon');

    if (!toggleCollapse) {
      iconClasses.push("ddc-icon-".concat(headingIconStyle));
    }

    if (headingIconSize) {
      iconClasses.push("ddc-icon-size-".concat(headingIconSize));
    }

    if (headingIconClasses) {
      iconClasses.push(headingIconClasses);
    }
  }

  return iconClasses;
};

var getHeadingClasses = function getHeadingClasses(prefs, deviceType, toggleCollapse) {
  var headingClasses = [];
  var headingSize = prefs.headingSize,
      headingStyles = prefs.headingStyles;
  headingClasses.push('widget-heading');

  if (deviceType === 'MOBILE') {
    headingClasses.push('ddc-heading');
  }

  if (headingSize) {
    headingClasses.push(headingSize);
  }

  if (headingStyles) {
    headingClasses.push("ddc-heading-".concat(headingStyles));
  }

  if (toggleCollapse) {
    headingClasses.push('collapse-heading');
  }

  return headingClasses;
};

var getWidgetComponents = function getWidgetComponents(Widget, store, widgetId) {
  var state = store.getState();
  var prefs = state.prefs || {};
  var toggleCollapse = prefs.widgetHeading && prefs.toggleCollapse === 'true' || false;
  var showIcon = prefs.headingIconStyle ? true : toggleCollapse;
  return _react.default.createElement(_reactRedux.Provider, {
    store: store
  }, _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_WidgetHeading.default, {
    HeadingTag: prefs.headingTag,
    headingText: prefs.widgetHeading,
    widgetId: widgetId,
    toggleCollapse: toggleCollapse,
    showIcon: showIcon,
    headingClasses: getHeadingClasses(prefs, state.requestData.deviceType, toggleCollapse),
    iconClasses: getIconClasses(prefs, showIcon, toggleCollapse)
  }), _react.default.createElement(_Collapse.default, {
    id: widgetId,
    toggleCollapse: toggleCollapse
  }, _react.default.createElement(Widget, null))));
};

exports.getWidgetComponents = getWidgetComponents;

/***/ }),
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
(function() {

/* eslint-env browser,amd,node */
//
// usertiming.js
//
// A polyfill for UserTiming (http://www.w3.org/TR/user-timing/)
//
// Copyright 2013 Nic Jansma
// http://nicj.net
//
// https://github.com/nicjansma/usertiming.js
//
// Licensed under the MIT license
//
(function(window) {
    "use strict";

    // allow running in Node.js environment
    if (typeof window === "undefined") {
        window = {};
    }

    // prepare base perf object
    if (typeof window.performance === "undefined") {
        window.performance = {};
    }

    // We need to keep a global reference to the window.performance object to
    // prevent any added properties from being garbage-collected in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137407
    window._perfRefForUserTimingPolyfill = window.performance;

    //
    // Note what we shimmed
    //
    window.performance.userTimingJsNow = false;
    window.performance.userTimingJsNowPrefixed = false;
    window.performance.userTimingJsUserTiming = false;
    window.performance.userTimingJsUserTimingPrefixed = false;
    window.performance.userTimingJsPerformanceTimeline = false;
    window.performance.userTimingJsPerformanceTimelinePrefixed = false;

    // for prefixed support
    var prefixes = [];
    var methods = [];
    var methodTest = null;
    var i, j;

    //
    // window.performance.now() shim
    //  http://www.w3.org/TR/hr-time/
    //
    if (typeof window.performance.now !== "function") {
        window.performance.userTimingJsNow = true;

        // copy prefixed version over if it exists
        methods = ["webkitNow", "msNow", "mozNow"];

        for (i = 0; i < methods.length; i++) {
            if (typeof window.performance[methods[i]] === "function") {
                window.performance.now = window.performance[methods[i]];

                window.performance.userTimingJsNowPrefixed = true;

                break;
            }
        }

        //
        // now() should be a DOMHighResTimeStamp, which is defined as being a time relative
        // to navigationStart of the PerformanceTiming (PT) interface.  If this browser supports
        // PT, use that as our relative start.  Otherwise, use "now" as the start and all other
        // now() calls will be relative to our initialization.
        //

        var nowOffset = +(new Date());
        if (window.performance.timing && window.performance.timing.navigationStart) {
            nowOffset = window.performance.timing.navigationStart;
        } else if (typeof process !== "undefined" && typeof process.hrtime === "function") {
            nowOffset = process.hrtime();
            window.performance.now = function() {
                var time = process.hrtime(nowOffset);
                return time[0] * 1e3 + time[1] * 1e-6;
            }
        }

        if (typeof window.performance.now !== "function") {
            // No browser support, fall back to Date.now
            if (Date.now) {
                window.performance.now = function() {
                    return Date.now() - nowOffset;
                };
            } else {
                // no Date.now support, get the time from new Date()
                window.performance.now = function() {
                    return +(new Date()) - nowOffset;
                };
            }
        }
    }

    //
    // PerformanceTimeline (PT) shims
    //  http://www.w3.org/TR/performance-timeline/
    //

    /**
     * Adds an object to our internal Performance Timeline array.
     *
     * Will be blank if the environment supports PT.
     */
    var addToPerformanceTimeline = function() {
    };

    /**
     * Clears the specified entry types from our timeline array.
     *
     * Will be blank if the environment supports PT.
     */
    var clearEntriesFromPerformanceTimeline = function() {
    };

    // performance timeline array
    var performanceTimeline = [];

    // whether or not the timeline will require sort on getEntries()
    var performanceTimelineRequiresSort = false;

    // whether or not ResourceTiming is natively supported but UserTiming is
    // not (eg Firefox 35)
    var hasNativeGetEntriesButNotUserTiming = false;

    //
    // If getEntries() and mark() aren't defined, we'll assume
    // we have to shim at least some PT functions.
    //
    if (typeof window.performance.getEntries !== "function" ||
        typeof window.performance.mark !== "function") {

        if (typeof window.performance.getEntries === "function" &&
            typeof window.performance.mark !== "function") {
            hasNativeGetEntriesButNotUserTiming = true;
        }

        window.performance.userTimingJsPerformanceTimeline = true;

        // copy prefixed version over if it exists
        prefixes = ["webkit", "moz"];
        methods = ["getEntries", "getEntriesByName", "getEntriesByType"];

        for (i = 0; i < methods.length; i++) {
            for (j = 0; j < prefixes.length; j++) {
                // prefixed method will likely have an upper-case first letter
                methodTest = prefixes[j] + methods[i].substr(0, 1).toUpperCase() + methods[i].substr(1);

                if (typeof window.performance[methodTest] === "function") {
                    window.performance[methods[i]] = window.performance[methodTest];

                    window.performance.userTimingJsPerformanceTimelinePrefixed = true;
                }
            }
        }

        /**
         * Adds an object to our internal Performance Timeline array.
         *
         * @param {Object} obj PerformanceEntry
         */
        addToPerformanceTimeline = function(obj) {
            performanceTimeline.push(obj);

            //
            // If we insert a measure, its startTime may be out of order
            // from the rest of the entries because the use can use any
            // mark as the start time.  If so, note we have to sort it before
            // returning getEntries();
            //
            if (obj.entryType === "measure") {
                performanceTimelineRequiresSort = true;
            }
        };

        /**
         * Ensures our PT array is in the correct sorted order (by startTime)
         */
        var ensurePerformanceTimelineOrder = function() {
            if (!performanceTimelineRequiresSort) {
                return;
            }

            //
            // Measures, which may be in this list, may enter the list in
            // an unsorted order. For example:
            //
            //  1. measure("a")
            //  2. mark("start_mark")
            //  3. measure("b", "start_mark")
            //  4. measure("c")
            //  5. getEntries()
            //
            // When calling #5, we should return [a,c,b] because technically the start time
            // of c is "0" (navigationStart), which will occur before b's start time due to the mark.
            //
            performanceTimeline.sort(function(a, b) {
                return a.startTime - b.startTime;
            });

            performanceTimelineRequiresSort = false;
        };

        /**
         * Clears the specified entry types from our timeline array.
         *
         * @param {string} entryType Entry type (eg "mark" or "measure")
         * @param {string} [name] Entry name (optional)
         */
        clearEntriesFromPerformanceTimeline = function(entryType, name) {
            // clear all entries from the perf timeline
            i = 0;
            while (i < performanceTimeline.length) {
                if (performanceTimeline[i].entryType !== entryType) {
                    // unmatched entry type
                    i++;
                    continue;
                }

                if (typeof name !== "undefined" && performanceTimeline[i].name !== name) {
                    // unmatched name
                    i++;
                    continue;
                }

                // this entry matches our criteria, remove just it
                performanceTimeline.splice(i, 1);
            }
        };

        if (typeof window.performance.getEntries !== "function" || hasNativeGetEntriesButNotUserTiming) {
            var origGetEntries = window.performance.getEntries;

            /**
             * Gets all entries from the Performance Timeline.
             * http://www.w3.org/TR/performance-timeline/#dom-performance-getentries
             *
             * NOTE: This will only ever return marks and measures.
             *
             * @returns {PerformanceEntry[]} Array of PerformanceEntrys
             */
            window.performance.getEntries = function() {
                ensurePerformanceTimelineOrder();

                // get a copy of all of our entries
                var entries = performanceTimeline.slice(0);

                // if there was a native version of getEntries, add that
                if (hasNativeGetEntriesButNotUserTiming && origGetEntries) {
                    // merge in native
                    Array.prototype.push.apply(entries, origGetEntries.call(window.performance));

                    // sort by startTime
                    entries.sort(function(a, b) {
                        return a.startTime - b.startTime;
                    });
                }

                return entries;
            };
        }

        if (typeof window.performance.getEntriesByType !== "function" || hasNativeGetEntriesButNotUserTiming) {
            var origGetEntriesByType = window.performance.getEntriesByType;

            /**
             * Gets all entries from the Performance Timeline of the specified type.
             * http://www.w3.org/TR/performance-timeline/#dom-performance-getentriesbytype
             *
             * NOTE: This will only work for marks and measures.
             *
             * @param {string} entryType Entry type (eg "mark" or "measure")
             *
             * @returns {PerformanceEntry[]} Array of PerformanceEntrys
             */
            window.performance.getEntriesByType = function(entryType) {
                // we only support marks/measures
                if (typeof entryType === "undefined" ||
                    (entryType !== "mark" && entryType !== "measure")) {

                    if (hasNativeGetEntriesButNotUserTiming && origGetEntriesByType) {
                        // native version exists, forward
                        return origGetEntriesByType.call(window.performance, entryType);
                    }

                    return [];
                }

                // see note in ensurePerformanceTimelineOrder() on why this is required
                if (entryType === "measure") {
                    ensurePerformanceTimelineOrder();
                }

                // find all entries of entryType
                var entries = [];
                for (i = 0; i < performanceTimeline.length; i++) {
                    if (performanceTimeline[i].entryType === entryType) {
                        entries.push(performanceTimeline[i]);
                    }
                }

                return entries;
            };
        }

        if (typeof window.performance.getEntriesByName !== "function" || hasNativeGetEntriesButNotUserTiming) {
            var origGetEntriesByName = window.performance.getEntriesByName;

            /**
             * Gets all entries from the Performance Timeline of the specified
             * name, and optionally, type.
             * http://www.w3.org/TR/performance-timeline/#dom-performance-getentriesbyname
             *
             * NOTE: This will only work for marks and measures.
             *
             * @param {string} name Entry name
             * @param {string} [entryType] Entry type (eg "mark" or "measure")
             *
             * @returns {PerformanceEntry[]} Array of PerformanceEntrys
             */
            window.performance.getEntriesByName = function(name, entryType) {
                if (entryType && entryType !== "mark" && entryType !== "measure") {
                    if (hasNativeGetEntriesButNotUserTiming && origGetEntriesByName) {
                        // native version exists, forward
                        return origGetEntriesByName.call(window.performance, name, entryType);
                    }

                    return [];
                }

                // see note in ensurePerformanceTimelineOrder() on why this is required
                if (typeof entryType !== "undefined" && entryType === "measure") {
                    ensurePerformanceTimelineOrder();
                }

                // find all entries of the name and (optionally) type
                var entries = [];
                for (i = 0; i < performanceTimeline.length; i++) {
                    if (typeof entryType !== "undefined" &&
                        performanceTimeline[i].entryType !== entryType) {
                        continue;
                    }

                    if (performanceTimeline[i].name === name) {
                        entries.push(performanceTimeline[i]);
                    }
                }

                if (hasNativeGetEntriesButNotUserTiming && origGetEntriesByName) {
                    // merge in native
                    Array.prototype.push.apply(entries, origGetEntriesByName.call(window.performance, name, entryType));

                    // sort by startTime
                    entries.sort(function(a, b) {
                        return a.startTime - b.startTime;
                    });
                }

                return entries;
            };
        }
    }

    //
    // UserTiming support
    //
    if (typeof window.performance.mark !== "function") {
        window.performance.userTimingJsUserTiming = true;

        // copy prefixed version over if it exists
        prefixes = ["webkit", "moz", "ms"];
        methods = ["mark", "measure", "clearMarks", "clearMeasures"];

        for (i = 0; i < methods.length; i++) {
            for (j = 0; j < prefixes.length; j++) {
                // prefixed method will likely have an upper-case first letter
                methodTest = prefixes[j] + methods[i].substr(0, 1).toUpperCase() + methods[i].substr(1);

                if (typeof window.performance[methodTest] === "function") {
                    window.performance[methods[i]] = window.performance[methodTest];

                    window.performance.userTimingJsUserTimingPrefixed = true;
                }
            }
        }

        // only used for measure(), to quickly see the latest timestamp of a mark
        var marks = {};

        if (typeof window.performance.mark !== "function") {
            /**
             * UserTiming mark
             * http://www.w3.org/TR/user-timing/#dom-performance-mark
             *
             * @param {string} markName Mark name
             */
            window.performance.mark = function(markName) {
                var now = window.performance.now();

                // mark name is required
                if (typeof markName === "undefined") {
                    throw new SyntaxError("Mark name must be specified");
                }

                // mark name can't be a NT timestamp
                if (window.performance.timing && markName in window.performance.timing) {
                    throw new SyntaxError("Mark name is not allowed");
                }

                if (!marks[markName]) {
                    marks[markName] = [];
                }

                marks[markName].push(now);

                // add to perf timeline as well
                addToPerformanceTimeline({
                    entryType: "mark",
                    name: markName,
                    startTime: now,
                    duration: 0
                });
            };
        }

        if (typeof window.performance.clearMarks !== "function") {
            /**
             * UserTiming clear marks
             * http://www.w3.org/TR/user-timing/#dom-performance-clearmarks
             *
             * @param {string} markName Mark name
             */
            window.performance.clearMarks = function(markName) {
                if (!markName) {
                    // clear all marks
                    marks = {};
                } else {
                    marks[markName] = [];
                }

                clearEntriesFromPerformanceTimeline("mark", markName);
            };
        }

        if (typeof window.performance.measure !== "function") {
            /**
             * UserTiming measure
             * http://www.w3.org/TR/user-timing/#dom-performance-measure
             *
             * @param {string} measureName Measure name
             * @param {string} [startMark] Start mark name
             * @param {string} [endMark] End mark name
             */
            window.performance.measure = function(measureName, startMark, endMark) {
                var now = window.performance.now();

                if (typeof measureName === "undefined") {
                    throw new SyntaxError("Measure must be specified");
                }

                // if there isn't a startMark, we measure from navigationStart to now
                if (!startMark) {
                    // add to perf timeline as well
                    addToPerformanceTimeline({
                        entryType: "measure",
                        name: measureName,
                        startTime: 0,
                        duration: now
                    });

                    return;
                }

                //
                // If there is a startMark, check for it first in the NavigationTiming interface,
                // then check our own marks.
                //
                var startMarkTime = 0;
                if (window.performance.timing && startMark in window.performance.timing) {
                    // mark cannot have a timing of 0
                    if (startMark !== "navigationStart" && window.performance.timing[startMark] === 0) {
                        throw new Error(startMark + " has a timing of 0");
                    }

                    // time is the offset of this mark to navigationStart's time
                    startMarkTime = window.performance.timing[startMark] - window.performance.timing.navigationStart;
                } else if (startMark in marks) {
                    startMarkTime = marks[startMark][marks[startMark].length - 1];
                } else {
                    throw new Error(startMark + " mark not found");
                }

                //
                // If there is a endMark, check for it first in the NavigationTiming interface,
                // then check our own marks.
                //
                var endMarkTime = now;

                if (endMark) {
                    endMarkTime = 0;

                    if (window.performance.timing && endMark in window.performance.timing) {
                        // mark cannot have a timing of 0
                        if (endMark !== "navigationStart" && window.performance.timing[endMark] === 0) {
                            throw new Error(endMark + " has a timing of 0");
                        }

                        // time is the offset of this mark to navigationStart's time
                        endMarkTime = window.performance.timing[endMark] - window.performance.timing.navigationStart;
                    } else if (endMark in marks) {
                        endMarkTime = marks[endMark][marks[endMark].length - 1];
                    } else {
                        throw new Error(endMark + " mark not found");
                    }
                }

                // add to our measure array
                var duration = endMarkTime - startMarkTime;

                // add to perf timeline as well
                addToPerformanceTimeline({
                    entryType: "measure",
                    name: measureName,
                    startTime: startMarkTime,
                    duration: duration
                });
            };
        }

        if (typeof window.performance.clearMeasures !== "function") {
            /**
             * UserTiming clear measures
             * http://www.w3.org/TR/user-timing/#dom-performance-clearmeasures
             *
             * @param {string} measureName Measure name
             */
            window.performance.clearMeasures = function(measureName) {
                clearEntriesFromPerformanceTimeline("measure", measureName);
            };
        }
    }

    //
    // Export UserTiming to the appropriate location.
    //
    // When included directly via a script tag in the browser, we're good as we've been
    // updating the window.performance object.
    //
    if (true) {
        //
        // AMD / RequireJS
        //
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
            return window.performance;
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module !== "undefined" && typeof module.exports !== "undefined") {
        //
        // Node.js
        //
        module.exports = window.performance;
    }
}(typeof window !== "undefined" ? window : undefined));


/*** EXPORTS FROM exports-loader ***/
module.exports = global.performance;
}.call(global));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63), __webpack_require__(19)))

/***/ }),
/* 57 */
/***/ (function(module, exports) {

/**
 * lodash 3.7.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * The base implementation of `get` without support for string paths
 * and default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path of the property to get.
 * @param {string} [pathKey] The key representation of path.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path, pathKey) {
  if (object == null) {
    return;
  }
  if (pathKey !== undefined && pathKey in toObject(object)) {
    path = [pathKey];
  }
  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[path[index++]];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */
function toObject(value) {
  return isObject(value) ? value : Object(value);
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = baseGet;


/***/ }),
/* 58 */
/***/ (function(module, exports) {

/**
 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = getNative;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.8.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var isArray = __webpack_require__(61);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `value` to a string if it's not one. An empty string is returned
 * for `null` or `undefined` values.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  return value == null ? '' : (value + '');
}

/**
 * Converts `value` to property path array if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Array} Returns the property path array.
 */
function toPath(value) {
  if (isArray(value)) {
    return value;
  }
  var result = [];
  baseToString(value).replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
}

module.exports = toPath;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var getNative = __webpack_require__(58);

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Native method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeNow = getNative(Date, 'now');

/**
 * Gets the number of milliseconds that have elapsed since the Unix epoch
 * (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @category Date
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => logs the number of milliseconds it took for the deferred function to be invoked
 */
var now = nativeNow || function() {
  return new Date().getTime();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed invocations. Provide an options object to indicate that `func`
 * should be invoked on the leading and/or trailing edge of the `wait` timeout.
 * Subsequent calls to the debounced function return the result of the last
 * `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
 * on the trailing edge of the timeout only if the the debounced function is
 * invoked more than once during the `wait` timeout.
 *
 * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.leading=false] Specify invoking on the leading
 *  edge of the timeout.
 * @param {number} [options.maxWait] The maximum time `func` is allowed to be
 *  delayed before it is invoked.
 * @param {boolean} [options.trailing=true] Specify invoking on the trailing
 *  edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // avoid costly calculations while the window size is in flux
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
 * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // ensure `batchLog` is invoked once after 1 second of debounced calls
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', _.debounce(batchLog, 250, {
 *   'maxWait': 1000
 * }));
 *
 * // cancel a debounced call
 * var todoChanges = _.debounce(batchLog, 1000);
 * Object.observe(models.todo, todoChanges);
 *
 * Object.observe(models, function(changes) {
 *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
 *     todoChanges.cancel();
 *   }
 * }, ['delete']);
 *
 * // ...at some point `models.todo` is changed
 * models.todo.completed = true;
 *
 * // ...before 1 second has passed `models.todo` is deleted
 * // which cancels the debounced `todoChanges` call
 * delete models.todo;
 */
function debounce(func, wait, options) {
  var args,
      maxTimeoutId,
      result,
      stamp,
      thisArg,
      timeoutId,
      trailingCall,
      lastCalled = 0,
      maxWait = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = wait < 0 ? 0 : (+wait || 0);
  if (options === true) {
    var leading = true;
    trailing = false;
  } else if (isObject(options)) {
    leading = !!options.leading;
    maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function cancel() {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    if (maxTimeoutId) {
      clearTimeout(maxTimeoutId);
    }
    lastCalled = 0;
    maxTimeoutId = timeoutId = trailingCall = undefined;
  }

  function complete(isCalled, id) {
    if (id) {
      clearTimeout(id);
    }
    maxTimeoutId = timeoutId = trailingCall = undefined;
    if (isCalled) {
      lastCalled = now();
      result = func.apply(thisArg, args);
      if (!timeoutId && !maxTimeoutId) {
        args = thisArg = undefined;
      }
    }
  }

  function delayed() {
    var remaining = wait - (now() - stamp);
    if (remaining <= 0 || remaining > wait) {
      complete(trailingCall, maxTimeoutId);
    } else {
      timeoutId = setTimeout(delayed, remaining);
    }
  }

  function maxDelayed() {
    complete(trailing, timeoutId);
  }

  function debounced() {
    args = arguments;
    stamp = now();
    thisArg = this;
    trailingCall = trailing && (timeoutId || !leading);

    if (maxWait === false) {
      var leadingCall = leading && !timeoutId;
    } else {
      if (!maxTimeoutId && !leading) {
        lastCalled = stamp;
      }
      var remaining = maxWait - (stamp - lastCalled),
          isCalled = remaining <= 0 || remaining > maxWait;

      if (isCalled) {
        if (maxTimeoutId) {
          maxTimeoutId = clearTimeout(maxTimeoutId);
        }
        lastCalled = stamp;
        result = func.apply(thisArg, args);
      }
      else if (!maxTimeoutId) {
        maxTimeoutId = setTimeout(maxDelayed, remaining);
      }
    }
    if (isCalled && timeoutId) {
      timeoutId = clearTimeout(timeoutId);
    }
    else if (!timeoutId && wait !== maxWait) {
      timeoutId = setTimeout(delayed, wait);
    }
    if (leadingCall) {
      isCalled = true;
      result = func.apply(thisArg, args);
    }
    if (isCalled && !timeoutId && !maxTimeoutId) {
      args = thisArg = undefined;
    }
    return result;
  }
  debounced.cancel = cancel;
  return debounced;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = debounce;


/***/ }),
/* 61 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var arrayTag = '[object Array]',
    funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeIsArray = getNative(Array, 'isArray');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */
var isArray = nativeIsArray || function(value) {
  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = isArray;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * DEVELOPED BY
 * GIL LOPES BUENO
 * gilbueno.mail@gmail.com
 *
 * WORKS WITH:
 * IE8*, IE 9+, FF 4+, SF 5+, WebKit, CH 7+, OP 12+, BESEN, Rhino 1.7+
 * For IE8 (and other legacy browsers) WatchJS will use dirty checking  
 *
 * FORK:
 * https://github.com/melanke/Watch.JS
 *
 * LICENSE: MIT
 */


(function (factory) {
    if (true) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like enviroments that support module.exports,
        // like Node.
        module.exports = factory();
    } else if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(factory);
    } else {
        // Browser globals
        window.WatchJS = factory();
        window.watch = window.WatchJS.watch;
        window.unwatch = window.WatchJS.unwatch;
        window.callWatchers = window.WatchJS.callWatchers;
    }
}(function () {

    var WatchJS = {
        noMore: false,        // use WatchJS.suspend(obj) instead
        useDirtyCheck: false, // use only dirty checking to track changes.
        preserveExistingSetters: false
    },
    lengthsubjects = [];
    
    var dirtyChecklist = [];
    var pendingChanges = []; // used coalesce changes from defineProperty and __defineSetter__
    
    var supportDefineProperty = false;
    try {
        supportDefineProperty = Object.defineProperty && Object.defineProperty({},'x', {});
    } catch(ex) {  /* not supported */  }

    var isFunction = function (functionToCheck) {
        var getType = {};
        return functionToCheck && getType.toString.call(functionToCheck) == '[object Function]';
    };

    var isInt = function (x) {
        return x % 1 === 0;
    };

    var isArray = function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };

    var isObject = function(obj) {
        return {}.toString.apply(obj) === '[object Object]';
    };
    
    var getObjDiff = function(a, b){
        var aplus = [],
        bplus = [];

        if(!(typeof a == "string") && !(typeof b == "string")){

            if (isArray(a) && b) {
                for (var i=0; i<a.length; i++) {
                    if (b[i] === undefined) aplus.push(i);
                }
            } else {
                for(var i in a){
                    if (a.hasOwnProperty(i)) {
                        if(b && !b.hasOwnProperty(i)) {
                            aplus.push(i);
                        }
                    }
                }
            }

            if (isArray(b) && a) {
                for (var j=0; j<b.length; j++) {
                    if (a[j] === undefined) bplus.push(j);
                }
            } else {
                for(var j in b){
                    if (b.hasOwnProperty(j)) {
                        if(a && !a.hasOwnProperty(j)) {
                            bplus.push(j);
                        }
                    }
                }
            }
        }

        return {
            added: aplus,
            removed: bplus
        }
    };

    var clone = function(obj){

        if (null == obj || "object" != typeof obj) {
            return obj;
        }

        var copy = obj.constructor();

        for (var attr in obj) {
            copy[attr] = obj[attr];
        }

        return copy;        

    }

    var getExistingSetter = function (obj, propName) {
        if (WatchJS.preserveExistingSetters) {
            var existing = Object.getOwnPropertyDescriptor(obj, propName);
            return existing.set;
        }

        return undefined;
    }

    var defineGetAndSet = function (obj, propName, getter, setter) {
        try {
            var existingSetter = getExistingSetter(obj, propName);
            Object.defineProperty(obj, propName, {
                get: getter,
                set: function(value) {
                    setter.call(this, value, true); // coalesce changes
                    if (existingSetter) {
                        existingSetter(value);
                    }
                },
                enumerable: true,
                configurable: true
            });
        }
        catch(e1) {
            try{
                Object.prototype.__defineGetter__.call(obj, propName, getter);
                Object.prototype.__defineSetter__.call(obj, propName, function(value) {
                    setter.call(this,value,true); // coalesce changes
                });
            }
            catch(e2) {
                observeDirtyChanges(obj,propName,setter);
                //throw new Error("watchJS error: browser not supported :/")
            }
        }

    };

    var defineProp = function (obj, propName, value) {
        try {
            Object.defineProperty(obj, propName, {
                enumerable: false,
                configurable: true,
                writable: false,
                value: value
            });
        } catch(error) {
            obj[propName] = value;
        }
    };

    var observeDirtyChanges = function(obj,propName,setter) {
        dirtyChecklist[dirtyChecklist.length] = {
            prop:       propName,
            object:     obj,
            orig:       clone(obj[propName]),
            callback:   setter
        }        
    }
    
    var watch = function () {

        if (isFunction(arguments[1])) {
            watchAll.apply(this, arguments);
        } else if (isArray(arguments[1])) {
            watchMany.apply(this, arguments);
        } else {
            watchOne.apply(this, arguments);
        }

    };


    var watchAll = function (obj, watcher, level, addNRemove) {

        if ((typeof obj == "string") || (!(obj instanceof Object) && !isArray(obj))) { //accepts only objects and array (not string)
            return;
        }

        if(isArray(obj)) {
            defineWatcher(obj, "__watchall__", watcher, level); // watch all changes on the array
            if (level===undefined||level > 0) {
                for (var prop = 0; prop < obj.length; prop++) { // watch objects in array
                   watchAll(obj[prop],watcher,level, addNRemove);
                }
            }
        } 
        else {
            var prop,props = [];
            for (prop in obj) { //for each attribute if obj is an object
                if (prop == "$val" || (!supportDefineProperty && prop === 'watchers')) {
                    continue;
                }

                if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                    props.push(prop); //put in the props
                }
            }
            watchMany(obj, props, watcher, level, addNRemove); //watch all items of the props
        }


        if (addNRemove) {
            pushToLengthSubjects(obj, "$$watchlengthsubjectroot", watcher, level);
        }
    };


    var watchMany = function (obj, props, watcher, level, addNRemove) {

        if ((typeof obj == "string") || (!(obj instanceof Object) && !isArray(obj))) { //accepts only objects and array (not string)
            return;
        }

        for (var i=0; i<props.length; i++) { //watch each property
            var prop = props[i];
            watchOne(obj, prop, watcher, level, addNRemove);
        }

    };

    var watchOne = function (obj, prop, watcher, level, addNRemove) {
        if ((typeof obj == "string") || (!(obj instanceof Object) && !isArray(obj))) { //accepts only objects and array (not string)
            return;
        }

        if(isFunction(obj[prop])) { //dont watch if it is a function
            return;
        }
        if(obj[prop] != null && (level === undefined || level > 0)){
            watchAll(obj[prop], watcher, level!==undefined? level-1 : level); //recursively watch all attributes of this
        }

        defineWatcher(obj, prop, watcher, level);

        if(addNRemove && (level === undefined || level > 0)){
            pushToLengthSubjects(obj, prop, watcher, level);
        }

    };

    var unwatch = function () {

        if (isFunction(arguments[1])) {
            unwatchAll.apply(this, arguments);
        } else if (isArray(arguments[1])) {
            unwatchMany.apply(this, arguments);
        } else {
            unwatchOne.apply(this, arguments);
        }

    };

    var unwatchAll = function (obj, watcher) {

        if (obj instanceof String || (!(obj instanceof Object) && !isArray(obj))) { //accepts only objects and array (not string)
            return;
        }

        if (isArray(obj)) {
            var props = ['__watchall__'];
            for (var prop = 0; prop < obj.length; prop++) { //for each item if obj is an array
                props.push(prop); //put in the props
            }
            unwatchMany(obj, props, watcher); //watch all itens of the props
        } else {
            var unwatchPropsInObject = function (obj2) {
                var props = [];
                for (var prop2 in obj2) { //for each attribute if obj is an object
                    if (obj2.hasOwnProperty(prop2)) {
                        if (obj2[prop2] instanceof Object) {
                            unwatchPropsInObject(obj2[prop2]); //recurs into object props
                        } else {
                            props.push(prop2); //put in the props
                        }
                    }
                }
                unwatchMany(obj2, props, watcher); //unwatch all of the props
            };
            unwatchPropsInObject(obj);
        }
    };


    var unwatchMany = function (obj, props, watcher) {

        for (var prop2 in props) { //watch each attribute of "props" if is an object
            if (props.hasOwnProperty(prop2)) {
                unwatchOne(obj, props[prop2], watcher);
            }
        }
    };

    var timeouts = [],
        timerID = null;
    function clearTimerID() {
        timerID = null;
        for(var i=0; i< timeouts.length; i++) {
            timeouts[i]();
        }
        timeouts.length = 0;
    }
    var getTimerID= function () {
        if (!timerID)  {
            timerID = setTimeout(clearTimerID);
        }
        return timerID;
    }
    var registerTimeout = function(fn) { // register function to be called on timeout
        if (timerID==null) getTimerID();
        timeouts[timeouts.length] = fn;
    }
    
    // Track changes made to an array, object or an object's property 
    // and invoke callback with a single change object containing type, value, oldvalue and array splices
    // Syntax: 
    //      trackChange(obj, callback, recursive, addNRemove)
    //      trackChange(obj, prop, callback, recursive, addNRemove)
    var trackChange = function() {
        var fn = (isFunction(arguments[2])) ? trackProperty : trackObject ;
        fn.apply(this,arguments);
    }

    // track changes made to an object and invoke callback with a single change object containing type, value and array splices
    var trackObject= function(obj, callback, recursive, addNRemove) {
        var change = null,lastTimerID = -1;
        var isArr = isArray(obj);
        var level,fn = function(prop, action, newValue, oldValue) {
            var timerID = getTimerID();
            if (lastTimerID!==timerID) { // check if timer has changed since last update
                lastTimerID = timerID;
                change = {
                    type: 'update'
                }
                change['value'] = obj;
                change['splices'] = null;
                registerTimeout(function() {
                    callback.call(this,change);
                    change = null;
                });
            }
            // create splices for array changes
            if (isArr && obj === this && change !== null)  {                
                if (action==='pop'||action==='shift') {
                    newValue = [];
                    oldValue = [oldValue];
                }
                else if (action==='push'||action==='unshift') {
                    newValue = [newValue];
                    oldValue = [];
                }
                else if (action!=='splice') { 
                    return; // return here - for reverse and sort operations we don't need to return splices. a simple update will do
                }
                if (!change.splices) change.splices = [];
                change.splices[change.splices.length] = {
                    index: prop,
                    deleteCount: oldValue ? oldValue.length : 0,
                    addedCount: newValue ? newValue.length : 0,
                    added: newValue,
                    deleted: oldValue
                };
            }

        }  
        level = (recursive==true) ? undefined : 0;        
        watchAll(obj,fn, level, addNRemove);
    }
    
    // track changes made to the property of an object and invoke callback with a single change object containing type, value, oldvalue and splices
    var trackProperty = function(obj,prop,callback,recursive, addNRemove) { 
        if (obj && prop) {
            watchOne(obj,prop,function(prop, action, newvalue, oldvalue) {
                var change = {
                    type: 'update'
                }
                change['value'] = newvalue;
                change['oldvalue'] = oldvalue;
                if (recursive && isObject(newvalue)||isArray(newvalue)) {
                    trackObject(newvalue,callback,recursive, addNRemove);
                }               
                callback.call(this,change);
            },0)
            
            if (recursive && isObject(obj[prop])||isArray(obj[prop])) {
                trackObject(obj[prop],callback,recursive, addNRemove);
            }                           
        }
    }
    
    
    var defineWatcher = function (obj, prop, watcher, level) {
        var newWatcher = false;
        var isArr = isArray(obj);
        
        if (!obj.watchers) {
            defineProp(obj, "watchers", {});
            if (isArr) {
                // watch array functions
                watchFunctions(obj, function(index,action,newValue, oldValue) {
                    addPendingChange(obj, index, action,newValue, oldValue);
                    if (level !== 0 && newValue && (isObject(newValue) || isArray(newValue))) {
                        var i,n, ln, wAll, watchList = obj.watchers[prop];
                        if ((wAll = obj.watchers['__watchall__'])) {
                            watchList = watchList ? watchList.concat(wAll) : wAll;
                        }
                        ln = watchList ?  watchList.length : 0;
                        for (i = 0; i<ln; i++) {
                            if (action!=='splice') {
                                watchAll(newValue, watchList[i], (level===undefined)?level:level-1);
                            }
                            else {
                                // watch spliced values
                                for(n=0; n < newValue.length; n++) {
                                    watchAll(newValue[n], watchList[i], (level===undefined)?level:level-1);
                                }
                            }
                        }
                    }
                });
            }
        }

        if (!obj.watchers[prop]) {
            obj.watchers[prop] = [];
            if (!isArr) newWatcher = true;
        }

        for (var i=0; i<obj.watchers[prop].length; i++) {
            if(obj.watchers[prop][i] === watcher){
                return;
            }
        }

        obj.watchers[prop].push(watcher); //add the new watcher to the watchers array

        if (newWatcher) {
            var val = obj[prop];            
            var getter = function () {
                return val;                        
            };

            var setter = function (newval, delayWatcher) {
                var oldval = val;
                val = newval;                
                if (level !== 0 
                    && obj[prop] && (isObject(obj[prop]) || isArray(obj[prop]))
                    && !obj[prop].watchers) {
                    // watch sub properties
                    var i,ln = obj.watchers[prop].length; 
                    for(i=0; i<ln; i++) {
                        watchAll(obj[prop], obj.watchers[prop][i], (level===undefined)?level:level-1);
                    }
                }

                //watchFunctions(obj, prop);
                
                if (isSuspended(obj, prop)) {
                    resume(obj, prop);
                    return;
                }

                if (!WatchJS.noMore){ // this does not work with Object.observe
                    //if (JSON.stringify(oldval) !== JSON.stringify(newval)) {
                    if (oldval !== newval) {
                        if (!delayWatcher) {
                            callWatchers(obj, prop, "set", newval, oldval);
                        }
                        else {
                            addPendingChange(obj, prop, "set", newval, oldval);
                        }
                        WatchJS.noMore = false;
                    }
                }
            };

            if (WatchJS.useDirtyCheck) {
                observeDirtyChanges(obj,prop,setter);
            }
            else {
                defineGetAndSet(obj, prop, getter, setter);
            }
        }

    };

    var callWatchers = function (obj, prop, action, newval, oldval) {
        if (prop !== undefined) {
            var ln, wl, watchList = obj.watchers[prop];
            if ((wl = obj.watchers['__watchall__'])) {
                watchList = watchList ? watchList.concat(wl) : wl;
            }
            ln = watchList ? watchList.length : 0;
            for (var wr=0; wr< ln; wr++) {
                watchList[wr].call(obj, prop, action, newval, oldval);
            }
        } else {
            for (var prop in obj) {//call all
                if (obj.hasOwnProperty(prop)) {
                    callWatchers(obj, prop, action, newval, oldval);
                }
            }
        }
    };

    var methodNames = ['pop', 'push', 'reverse', 'shift', 'sort', 'slice', 'unshift', 'splice'];
    var defineArrayMethodWatcher = function (obj, original, methodName, callback) {
        defineProp(obj, methodName, function () {
            var index = 0;
            var i,newValue, oldValue, response;                        
            // get values before splicing array 
            if (methodName === 'splice') {
               var start = arguments[0];
               var end = start + arguments[1];
               oldValue = obj.slice(start,end);
               newValue = [];
               for(i=2;i<arguments.length;i++) {
                   newValue[i-2] = arguments[i];
               }
               index = start;
            } 
            else {
                newValue = arguments.length > 0 ? arguments[0] : undefined;
            } 

            response = original.apply(obj, arguments);
            if (methodName !== 'slice') {
                if (methodName === 'pop') {
                    oldValue = response;
                    index = obj.length;
                }
                else if (methodName === 'push') {
                    index = obj.length-1;
                }
                else if (methodName === 'shift') {
                    oldValue = response;
                }
                else if (methodName !== 'unshift' && newValue===undefined) {
                    newValue = response;
                }
                callback.call(obj, index, methodName,newValue, oldValue)
            }
            return response;
        });
    };

    var watchFunctions = function(obj, callback) {

        if (!isFunction(callback) || !obj || (obj instanceof String) || (!isArray(obj))) {
            return;
        }

        for (var i = methodNames.length, methodName; i--;) {
            methodName = methodNames[i];
            defineArrayMethodWatcher(obj, obj[methodName], methodName, callback);
        }

    };

    var unwatchOne = function (obj, prop, watcher) {
        if (prop) {
            if (obj.watchers && obj.watchers[prop]) {
                if (watcher === undefined) {
                    delete obj.watchers[prop]; // remove all property watchers
                }
                else {
                    for (var i = 0; i < obj.watchers[prop].length; i++) {
                        var w = obj.watchers[prop][i];
                        if (w == watcher) {
                            obj.watchers[prop].splice(i, 1);
                        }
                    }
                }
            }
        } else {
            delete obj.watchers;
        }

        removeFromLengthSubjects(obj, prop, watcher);
        removeFromDirtyChecklist(obj, prop);
    };
    
    // suspend watchers until next update cycle
    var suspend = function(obj, prop) {
        if (obj.watchers) {
            var name = '__wjs_suspend__'+(prop!==undefined ? prop : '');
            obj.watchers[name] = true;
        }
    }
    
    var isSuspended = function(obj, prop) {
        return obj.watchers 
               && (obj.watchers['__wjs_suspend__'] || 
                   obj.watchers['__wjs_suspend__'+prop]);
    }
    
    // resumes preivously suspended watchers
    var resume = function(obj, prop) {
        registerTimeout(function() {
            delete obj.watchers['__wjs_suspend__'];
            delete obj.watchers['__wjs_suspend__'+prop];
        })
    }

    var pendingTimerID = null;
    var addPendingChange = function(obj,prop, mode, newval, oldval) {
        pendingChanges[pendingChanges.length] = {
            obj:obj,
            prop: prop,
            mode: mode,
            newval: newval,
            oldval: oldval
        };
        if (pendingTimerID===null) {
            pendingTimerID = setTimeout(applyPendingChanges);
        }
    };
    
    
    var applyPendingChanges = function()  {
        // apply pending changes
        var change = null;
        pendingTimerID = null;
        for(var i=0;i < pendingChanges.length;i++) {
            change = pendingChanges[i];
            callWatchers(change.obj, change.prop, change.mode, change.newval, change.oldval);
        }
        if (change) {
            pendingChanges = [];
            change = null;
        }        
    }

    var loop = function(){

        // check for new or deleted props
        for(var i=0; i<lengthsubjects.length; i++) {

            var subj = lengthsubjects[i];

            if (subj.prop === "$$watchlengthsubjectroot") {

                var difference = getObjDiff(subj.obj, subj.actual);

                if(difference.added.length || difference.removed.length){
                    if(difference.added.length){
                        watchMany(subj.obj, difference.added, subj.watcher, subj.level - 1, true);
                    }

                    subj.watcher.call(subj.obj, "root", "differentattr", difference, subj.actual);
                }
                subj.actual = clone(subj.obj);


            } else {

                var difference = getObjDiff(subj.obj[subj.prop], subj.actual);

                if(difference.added.length || difference.removed.length){
                    if(difference.added.length){
                        for (var j=0; j<subj.obj.watchers[subj.prop].length; j++) {
                            watchMany(subj.obj[subj.prop], difference.added, subj.obj.watchers[subj.prop][j], subj.level - 1, true);
                        }
                    }

                    callWatchers(subj.obj, subj.prop, "differentattr", difference, subj.actual);
                }

                subj.actual = clone(subj.obj[subj.prop]);

            }

        }
        
        // start dirty check
        var n, value;
        if (dirtyChecklist.length > 0) {
            for (var i = 0; i < dirtyChecklist.length; i++) {
                n = dirtyChecklist[i];
                value = n.object[n.prop];
                if (!compareValues(n.orig, value)) {
                    n.orig = clone(value);
                    n.callback(value);
                }
            }
        }

    };

    var compareValues =  function(a,b) {
        var i, state = true;
        if (a!==b)  {
            if (isObject(a)) {
                for(i in a) {
                    if (!supportDefineProperty && i==='watchers') continue;
                    if (a[i]!==b[i]) {
                        state = false;
                        break;
                    };
                }
            }
            else {
                state = false;
            }
        }
        return state;
    }
    
    var pushToLengthSubjects = function(obj, prop, watcher, level){

        var actual;

        if (prop === "$$watchlengthsubjectroot") {
            actual =  clone(obj);
        } else {
            actual = clone(obj[prop]);
        }

        lengthsubjects.push({
            obj: obj,
            prop: prop,
            actual: actual,
            watcher: watcher,
            level: level
        });
    };

    var removeFromLengthSubjects = function(obj, prop, watcher){
        for (var i=0; i<lengthsubjects.length; i++) {
            var subj = lengthsubjects[i];

            if (subj.obj == obj) {
                if (!prop || subj.prop == prop) {
                    if (!watcher || subj.watcher == watcher) {
                        // if we splice off one item at position i
                        // we need to decrement i as the array is one item shorter
                        // so when we increment i in the loop statement we
                        // will land at the correct index.
                        // if it's not decremented, you won't delete all length subjects
                        lengthsubjects.splice(i--, 1);
                    }
                }
            }
        }

    };
    
    var removeFromDirtyChecklist = function(obj, prop){
        var notInUse;
        for (var i=0; i<dirtyChecklist.length; i++) {
            var n = dirtyChecklist[i];
            var watchers = n.object.watchers;
            notInUse = (
                n.object == obj 
                && (!prop || n.prop == prop)
                && watchers
                && (!prop || !watchers[prop] || watchers[prop].length == 0 )
            );
            if (notInUse)  {
                // we use the same syntax as in removeFromLengthSubjects
                dirtyChecklist.splice(i--, 1);
            }
        }

    };    

    setInterval(loop, 50);

    WatchJS.watch = watch;
    WatchJS.unwatch = unwatch;
    WatchJS.callWatchers = callWatchers;
    WatchJS.suspend = suspend; // suspend watchers    
    WatchJS.onChange = trackChange;  // track changes made to object or  it's property and return a single change object

    return WatchJS;

}));


/***/ }),
/* 63 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(60);

var _lodash2 = _interopRequireDefault(_lodash);

var _autoprefix = __webpack_require__(65);

var _autoprefix2 = _interopRequireDefault(_autoprefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function autoprefixes(styles) {
  return Object.keys(styles).reduce(function (obj, key) {
    return obj[key] = (0, _autoprefix2.default)(styles[key]), obj;
  }, {});
}

var styles = autoprefixes({
  wrapper: {
    position: 'fixed',
    width: 0,
    height: 0,
    top: 0,
    left: 0
  },

  dim: {
    position: 'fixed',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: 0,
    background: 'rgba(0, 0, 0, 0.2)',
    opacity: 1
  },

  dimAppear: {
    opacity: 0
  },

  dimTransparent: {
    pointerEvents: 'none'
  },

  dimHidden: {
    opacity: 0
  },

  dock: {
    position: 'fixed',
    zIndex: 1,
    boxShadow: '0 0 4px rgba(0, 0, 0, 0.3)',
    background: 'white',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%'
  },

  dockHidden: {
    opacity: 0
  },

  dockResizing: {
    transition: 'none'
  },

  dockContent: {
    width: '100%',
    height: '100%',
    overflow: 'auto'
  },

  resizer: {
    position: 'absolute',
    zIndex: 2,
    opacity: 0
  }
});

function getTransitions(duration) {
  return ['left', 'top', 'width', 'height'].map(function (p) {
    return p + ' ' + duration / 1000 + 's ease-out';
  });
}

function getDockStyles(_ref, _ref2) {
  var fluid = _ref.fluid;
  var dockStyle = _ref.dockStyle;
  var dockHiddenStyle = _ref.dockHiddenStyle;
  var duration = _ref.duration;
  var position = _ref.position;
  var isVisible = _ref.isVisible;
  var size = _ref2.size;
  var isResizing = _ref2.isResizing;
  var fullWidth = _ref2.fullWidth;
  var fullHeight = _ref2.fullHeight;

  var posStyle = void 0;
  var absSize = fluid ? size * 100 + '%' : size + 'px';

  function getRestSize(fullSize) {
    return fluid ? 100 - size * 100 + '%' : fullSize - size + 'px';
  }

  switch (position) {
    case 'left':
      posStyle = {
        width: absSize,
        left: isVisible ? 0 : '-' + absSize
      };
      break;
    case 'right':
      posStyle = {
        left: isVisible ? getRestSize(fullWidth) : fullWidth,
        width: absSize
      };
      break;
    case 'top':
      posStyle = {
        top: isVisible ? 0 : '-' + absSize,
        height: absSize
      };
      break;
    case 'bottom':
      posStyle = {
        top: isVisible ? getRestSize(fullHeight) : fullHeight,
        height: absSize
      };
      break;
  }

  var transitions = getTransitions(duration);

  return [styles.dock, (0, _autoprefix2.default)({
    transition: [].concat(_toConsumableArray(transitions), [!isVisible && 'opacity 0.01s linear ' + duration / 1000 + 's']).filter(function (t) {
      return t;
    }).join(',')
  }), dockStyle, (0, _autoprefix2.default)(posStyle), isResizing && styles.dockResizing, !isVisible && styles.dockHidden, !isVisible && dockHiddenStyle];
}

function getDimStyles(_ref3, _ref4) {
  var dimMode = _ref3.dimMode;
  var dimStyle = _ref3.dimStyle;
  var duration = _ref3.duration;
  var isVisible = _ref3.isVisible;
  var isTransitionStarted = _ref4.isTransitionStarted;

  return [styles.dim, (0, _autoprefix2.default)({
    transition: 'opacity ' + duration / 1000 + 's ease-out'
  }), dimStyle, dimMode === 'transparent' && styles.dimTransparent, !isVisible && styles.dimHidden, isTransitionStarted && isVisible && styles.dimAppear, isTransitionStarted && !isVisible && styles.dimDisappear];
}

function getResizerStyles(position) {
  var resizerStyle = void 0;
  var size = 10;

  switch (position) {
    case 'left':
      resizerStyle = {
        right: -size / 2,
        width: size,
        top: 0,
        height: '100%',
        cursor: 'col-resize'
      };
      break;
    case 'right':
      resizerStyle = {
        left: -size / 2,
        width: size,
        top: 0,
        height: '100%',
        cursor: 'col-resize'
      };
      break;
    case 'top':
      resizerStyle = {
        bottom: -size / 2,
        height: size,
        left: 0,
        width: '100%',
        cursor: 'row-resize'
      };
      break;
    case 'bottom':
      resizerStyle = {
        top: -size / 2,
        height: size,
        left: 0,
        width: '100%',
        cursor: 'row-resize'
      };
      break;
  }

  return [styles.resizer, (0, _autoprefix2.default)(resizerStyle)];
}

function getFullSize(position, fullWidth, fullHeight) {
  return position === 'left' || position === 'right' ? fullWidth : fullHeight;
}

var Dock = (_temp = _class = function (_Component) {
  _inherits(Dock, _Component);

  function Dock(props) {
    _classCallCheck(this, Dock);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Dock).call(this, props));

    _this.transitionEnd = function () {
      _this.setState({ isTransitionStarted: false });
    };

    _this.hideDim = function () {
      if (!_this.props.isVisible) {
        _this.setState({ isDimHidden: true });
      }
    };

    _this.handleDimClick = function () {
      if (_this.props.dimMode === 'opaque') {
        _this.props.onVisibleChange && _this.props.onVisibleChange(false);
      }
    };

    _this.handleResize = function () {
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(_this.updateWindowSize.bind(_this, true));
      } else {
        _this.updateWindowSize(true);
      }
    };

    _this.updateWindowSize = function (windowResize) {
      var sizeState = {
        fullWidth: window.innerWidth,
        fullHeight: window.innerHeight
      };

      if (windowResize) {
        _this.setState(_extends({}, sizeState, {
          isResizing: true,
          isWindowResizing: windowResize
        }));

        _this.debouncedUpdateWindowSizeEnd();
      } else {
        _this.setState(sizeState);
      }
    };

    _this.updateWindowSizeEnd = function () {
      _this.setState({
        isResizing: false,
        isWindowResizing: false
      });
    };

    _this.debouncedUpdateWindowSizeEnd = (0, _lodash2.default)(_this.updateWindowSizeEnd, 30);

    _this.handleWrapperLeave = function () {
      _this.setState({ isResizing: false });
    };

    _this.handleMouseDown = function () {
      _this.setState({ isResizing: true });
    };

    _this.handleMouseUp = function () {
      _this.setState({ isResizing: false });
    };

    _this.handleMouseMove = function (e) {
      if (!_this.state.isResizing || _this.state.isWindowResizing) return;
      e.preventDefault();

      var _this$props = _this.props;
      var position = _this$props.position;
      var fluid = _this$props.fluid;
      var _this$state = _this.state;
      var fullWidth = _this$state.fullWidth;
      var fullHeight = _this$state.fullHeight;
      var isControlled = _this$state.isControlled;
      var x = e.clientX;
      var y = e.clientY;

      var size = void 0;

      switch (position) {
        case 'left':
          size = fluid ? x / fullWidth : x;
          break;
        case 'right':
          size = fluid ? (fullWidth - x) / fullWidth : fullWidth - x;
          break;
        case 'top':
          size = fluid ? y / fullHeight : y;
          break;
        case 'bottom':
          size = fluid ? (fullHeight - y) / fullHeight : fullHeight - y;
          break;
      }

      _this.props.onSizeChange && _this.props.onSizeChange(size);

      if (!isControlled) {
        _this.setState({ size: size });
      }
    };

    _this.state = {
      isControlled: typeof props.size !== 'undefined',
      size: props.size || props.defaultSize,
      isDimHidden: !props.isVisible,
      fullWidth: typeof window !== 'undefined' && window.innerWidth,
      fullHeight: typeof window !== 'undefined' && window.innerHeight,
      isTransitionStarted: false,
      isWindowResizing: false
    };
    return _this;
  }

  _createClass(Dock, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('mouseup', this.handleMouseUp);
      window.addEventListener('mousemove', this.handleMouseMove);
      window.addEventListener('resize', this.handleResize);

      if (!window.fullWidth) {
        this.updateWindowSize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('mouseup', this.handleMouseUp);
      window.removeEventListener('mousemove', this.handleMouseMove);
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var isControlled = typeof nextProps.size !== 'undefined';

      this.setState({ isControlled: isControlled });

      if (isControlled && this.props.size !== nextProps.size) {
        this.setState({ size: nextProps.size });
      } else if (this.props.fluid !== nextProps.fluid) {
        this.updateSize(nextProps);
      }

      if (this.props.isVisible !== nextProps.isVisible) {
        this.setState({
          isTransitionStarted: true
        });
      }
    }
  }, {
    key: 'updateSize',
    value: function updateSize(props) {
      var _state = this.state;
      var fullWidth = _state.fullWidth;
      var fullHeight = _state.fullHeight;


      this.setState({
        size: props.fluid ? this.state.size / getFullSize(props.position, fullWidth, fullHeight) : getFullSize(props.position, fullWidth, fullHeight) * this.state.size
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (this.props.isVisible !== prevProps.isVisible) {
        if (!this.props.isVisible) {
          window.setTimeout(function () {
            return _this2.hideDim();
          }, this.props.duration);
        } else {
          this.setState({ isDimHidden: false });
        }

        window.setTimeout(function () {
          return _this2.setState({ isTransitionStarted: false });
        }, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var children = _props.children;
      var zIndex = _props.zIndex;
      var dimMode = _props.dimMode;
      var position = _props.position;
      var isVisible = _props.isVisible;
      var _state2 = this.state;
      var isResizing = _state2.isResizing;
      var size = _state2.size;
      var isDimHidden = _state2.isDimHidden;


      var dimStyles = Object.assign.apply(Object, [{}].concat(_toConsumableArray(getDimStyles(this.props, this.state))));
      var dockStyles = Object.assign.apply(Object, [{}].concat(_toConsumableArray(getDockStyles(this.props, this.state))));
      var resizerStyles = Object.assign.apply(Object, [{}].concat(_toConsumableArray(getResizerStyles(position))));

      return _react2.default.createElement(
        'div',
        { style: Object.assign({}, styles.wrapper, { zIndex: zIndex }) },
        dimMode !== 'none' && !isDimHidden && _react2.default.createElement('div', { style: dimStyles, onClick: this.handleDimClick }),
        _react2.default.createElement(
          'div',
          { style: dockStyles },
          _react2.default.createElement('div', { style: resizerStyles,
            onMouseDown: this.handleMouseDown }),
          _react2.default.createElement(
            'div',
            { style: styles.dockContent },
            typeof children === 'function' ? children({
              position: position,
              isResizing: isResizing,
              size: size,
              isVisible: isVisible
            }) : children
          )
        )
      );
    }
  }]);

  return Dock;
}(_react.Component), _class.propTypes = {
  position: _propTypes2.default.oneOf(['left', 'right', 'top', 'bottom']),
  zIndex: _propTypes2.default.number,
  fluid: _propTypes2.default.bool,
  size: _propTypes2.default.number,
  defaultSize: _propTypes2.default.number,
  dimMode: _propTypes2.default.oneOf(['none', 'transparent', 'opaque']),
  isVisible: _propTypes2.default.bool,
  onVisibleChange: _propTypes2.default.func,
  onSizeChange: _propTypes2.default.func,
  dimStyle: _propTypes2.default.object,
  dockStyle: _propTypes2.default.object,
  duration: _propTypes2.default.number
}, _class.defaultProps = {
  position: 'left',
  zIndex: 99999999,
  fluid: true,
  defaultSize: 0.3,
  dimMode: 'opaque',
  duration: 200
}, _temp);
exports.default = Dock;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = autoprefix;
// Same as https://github.com/SimenB/react-vendor-prefixes/blob/master/src/index.js,
// but dumber

var vendorSpecificProperties = ['animation', 'animationDelay', 'animationDirection', 'animationDuration', 'animationFillMode', 'animationIterationCount', 'animationName', 'animationPlayState', 'animationTimingFunction', 'appearance', 'backfaceVisibility', 'backgroundClip', 'borderImage', 'borderImageSlice', 'boxSizing', 'boxShadow', 'contentColumns', 'transform', 'transformOrigin', 'transformStyle', 'transition', 'transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction', 'perspective', 'perspectiveOrigin', 'userSelect'];

var prefixes = ['Moz', 'Webkit', 'ms', 'O'];

function prefixProp(key, value) {
  return prefixes.reduce(function (obj, pre) {
    return obj[pre + key[0].toUpperCase() + key.substr(1)] = value, obj;
  }, {});
}

function autoprefix(style) {
  return Object.keys(style).reduce(function (obj, key) {
    return vendorSpecificProperties.indexOf(key) !== -1 ? _extends({}, obj, prefixProp(key, style[key])) : obj;
  }, style);
}

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(69)


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(68);
} else {
  module.exports = require('./AppContainer.dev');
}

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */

var React = __webpack_require__(0);

var Component = React.Component;

var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'render',
    value: function render() {
      if (this.props.component) {
        return React.createElement(this.props.component, this.props.props);
      }

      return React.Children.only(this.props.children);
    }
  }]);

  return AppContainer;
}(Component);

module.exports = AppContainer;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(70);
} else {
  module.exports = require('./index.dev');
}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.AppContainer = __webpack_require__(67);

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(performance, global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56), __webpack_require__(19)))

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = DDC.BuiltModules["html-react-parser"]["0.4.7"];

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = Redux;

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = ReduxThunk;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(20);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.eca8a5baa5eb2b495fba.js